/** French translations */
import type { TranslationDict } from "./tr";

const fr: TranslationDict = {
  common: {
    privacyPre: "Vos données personnelles sont traitées conformément à notre ",
    privacyLink: "politique de confidentialité",
    termsLink: "Conditions d'utilisation",
    privacyPost: ".",
    all: "Tous",
    save: "Enregistrer",
    saving: "Enregistrement...",
    cancel: "Annuler",
    delete: "Supprimer",
    edit: "Modifier",
    add: "Ajouter",
    adding: "Ajout...",
    create: "Créer",
    creating: "Création...",
    close: "Fermer",
    /** Belge yazımı reddedildi (409 stale_write): veri tazelendi. */
    staleWrite: "Cet élément a été modifié ailleurs pendant votre saisie. La dernière version a été chargée — vérifiez votre modification et enregistrez à nouveau.",
    back: "Retour",
    loading: "Chargement...",
    loadMore: "En voir plus",
    perPage: "par page",
    logout: "Déconnexion",
    switchToLight: "Passer en mode clair",
    switchToDark: "Passer en mode sombre",
    error: "Erreur",
    unknownError: "Erreur inconnue",
    errorOccurred: "Une erreur est survenue",
    confirm: "Confirmer",
    phone: "Téléphone",
    email: "E-mail",
    name: "Nom",
    date: "Date",
    actions: "Actions",
    yes: "Oui",
    no: "Non",
    none: "Aucun",
    other: "Autre",
    total: "Total",
    language: "Langue",
    uploading: "Téléchargement...",
    upload: "Télécharger",
    skip: "Passer",
    chooseFile: "Choisir un fichier",
    remove: "Supprimer",
    help: "Aide",
    left: "restant",
    more: "Plus",
    otherPages: "Autres pages",
    optional: "facultatif",
  },
  nav: {
    dashboard: "Tableau de bord",
    guests: "Invités",
    sms: "SMS",
    moderation: "Modération",
    organizers: "Organisateurs",
    users: "Utilisateurs",
    weddings: "Mariages",
    myWeddings: "Mes Mariages",
    profile: "Mon Profil",
    home: "Accueil",
    rsvp: "RSVP",
    upload: "Télécharger",
    gallery: "Galerie",
    slideshow: "Scène",
    reji: "Reji",
    analytics: "Analytique QR",
    allWeddings: "Tous les Mariages",
    backToWeddings: "Retour aux Mariages",
    organizer: "Organisateur",
    maintenance: "Suivi des erreurs",
    controlCenter: "Centre de contrôle",
    smsCenter: "Centre SMS",
    site: "Ventes & Site",
    privacy: "Demandes RGPD/KVKK",
    print: "Impression",
    themes: "Thèmes",
    settings: "Paramètres",
    packages: "Mes formules",
  },

  auth: {
    welcomeTitle: "Bienvenue à Notre Mariage",
    loginTitle: "Connexion",
    loginDesc: "Nous vous enverrons un code de vérification par SMS",
    phoneLabel: "Téléphone",
    login: "Se connecter",
    verifyTitle: "Code de Vérification",
    verifyDesc: "Entrez le code à 6 chiffres envoyé sur votre téléphone",
    codeLabel: "Code",
    verify: "Vérifier",
    phonePlaceholder: "+33 X XX XX XX XX",
    loggingIn: "Connexion...",
    enterCode: "Entrez le code à 6 chiffres envoyé sur votre téléphone",
    verifying: "Vérification...",
    wrongNumber: "Changer de numéro",
    changeNumber: "Changer de numéro",
    turnstileRequired: "Veuillez compléter la vérification",
    codeFailed: "Échec de la vérification du code",
    logoutLabel: "Se déconnecter",
    codePlaceholder: "123456",
    otpUnavailable: "La vérification SMS est actuellement indisponible. Veuillez contacter l'organisateur.",
    invalidPhone: "Saisissez un numéro de téléphone valide — le 0 initial est accepté.",
    countrySelectLabel: "Indicatif pays",
    countrySearchPlaceholder: "Rechercher un pays…",
    noCountryResults: "Aucun pays trouvé",
    phoneHint: "Avec ou sans le 0 initial — nous corrigeons automatiquement",
    banned: "Votre accès à ce mariage a été suspendu. Veuillez contacter l'organisateur.",
    celebrationPrefix: "Une célébration d'amour :",
    tabLogin: "Se connecter",
    tabRegister: "S'inscrire",
    registerTitle: "S'inscrire",
    registerDesc: "Saisissez votre nom et votre numéro de téléphone pour rejoindre le mariage.",
    alreadyRegisteredTitle: "Déjà inscrit",
    alreadyRegisteredDesc: "Ce numéro est déjà enregistré — connectez-vous pour continuer.",
    alreadyRegisteredSwitch: "Se connecter",
  },
  organizerAuth: {
    signupClosed: "Aucun compte organisateur avec cet e-mail. Les nouveaux comptes sont ouverts après devis — demandez-en un via le formulaire sur wedding.mertbal.com.",
    title: "Connexion Organisateur",
    emailPrompt: "Entrez votre adresse e-mail",
    codePrompt: "Entrez le code envoyé à votre e-mail",
    emailLabel: "E-mail",
    sendCode: "Envoyer le Code",
    verifyCode: "Code de Vérification",
    login: "Se Connecter",
    changeEmail: "Utiliser un autre e-mail",
    emailPlaceholder: "organisateur@exemple.com",
    panelTitle: "Panneau Organisateur",
    tagline: "Gérez vos mariages",
    welcomeBack: "Bon retour",
    verifyTitle: "Vérifiez votre identité",
    verifyHint: "Si un compte existe pour {{email}}, nous avons envoyé un code à 6 chiffres. Sinon, cette adresse reçoit un e-mail d’information.",
    signupVerifyHint: "Nous avons envoyé le code à {{email}} — saisissez-le pour ouvrir votre compte.",
    noAccount: "Pas encore de compte ?",
    signupCta: "Créer un compte",
    quoteCta: "Demander un devis",
    haveAccount: "Vous avez déjà un compte ?",
    loginCta: "Se connecter",
    signupTitle: "Créer un compte",
    signupPrompt: "Saisissez votre nom et votre e-mail ; votre compte s’ouvre avec le code reçu par e-mail.",
    nameLabel: "Nom complet",
    namePlaceholder: "Marie Dupont",
    acceptTerms: "les conditions d’utilisation",
    acceptAnd: " et ",
    acceptKvkk: "la notice de confidentialité",
    acceptPost: " : je les ai lues et je les accepte.",
    createAccount: "Créer le compte",
    signupMissing: "Saisissez votre nom et acceptez les conditions.",
    signupClosedTitle: "Les nouveaux comptes s’ouvrent sur devis",
    signupClosedBody: "Remplissez le formulaire de notre site pour les tarifs ; nous ouvrirons votre compte.",
    disposableEmail: "Cette adresse e-mail n’est pas acceptée. Utilisez une adresse permanente.",
    emailAliasExists: "Un compte existe déjà pour cette boîte mail (la même adresse avec des points ou un +libellé). Connectez-vous avec votre adresse existante.",
    tooManySignups: "Trop d’inscriptions depuis ce réseau aujourd’hui. Réessayez plus tard.",
    accountNotFound: "Aucun compte n’est lié à cet e-mail, ou l’inscription a expiré. Réessayez.",
    secureGateway: "Accès sécurisé",
  },
  dashboard: {
    title: "Tableau de bord",
    totalGuests: "Total des Invités",
    attending: "Participant",
    people: "personnes",
    maybe: "Peut-être",
    notAttending: "Ne participe pas",
    pendingMedia: "Médias en Attente",
    approvedMedia: "Médias Approuvés",
    welcomeBack: "Bienvenue,",
    activityFeed: "Activité récente",
    quickActions: "Actions rapides",
    daysLeft: "jours restants",
    weddingPast: "Quelle belle journée !",
    inviteLink: "Lien d'invitation",
    inviteLinkHint: "Partagez ce lien avec vos invités pour rejoindre votre mariage.",
    copied: "Copié !",
    eventStatus: "Statut de l'événement",
    statusOn: "Activé",
    statusOff: "Désactivé",
    statusScheduled: "Planifié",
    recentMedia: "Photos récentes",
    noMediaYet: "Aucune photo approuvée pour l'instant",
    capacityUsed: "Capacité utilisée",
    pendingAlert: "photos en attente de révision",
    pendingAlertSub: "Ouvrir la file de modération",
    quickGuestsSub: "Gérer la liste des invités",
    quickModerationSub: "Réviser les téléchargements en attente",
    quickGallerySub: "Parcourir les médias approuvés",
    quickSettingsSub: "Paramètres du mariage",
    noActivity: "Aucune activité récente",
    qrFunnelTitle: "Tunnel QR",
    qrScans: "Scans",
    qrRegistrations: "Inscriptions",
    qrConversion: "Conversion",
    qrFunnelEmpty: "Aucun scan pour l'instant — partagez votre code QR",
    qrFunnelDetail: "Détails",
  },
  analytics: {
    title: "Analytique QR",
    summary: "Résumé",
    scans: "Scans",
    unique: "Uniques",
    registrations: "Inscriptions",
    conversion: "Conversion",
    byDay: "Temps",
    byDevice: "Appareil",
    byLocation: "Lieu",
    funnel: "Tunnel",
    unknown: "Inconnu",
    exportCsv: "Télécharger CSV",
    empty: "Aucun scan pour l'instant — partagez votre code QR",
    csvOk: "CSV téléchargé",
    csvErr: "Échec du téléchargement",
    peak: "Pic",
    share: "part",
    deviceMobile: "Mobile",
    deviceTablet: "Tablette",
    deviceDesktop: "Ordinateur",
    refresh: "Actualiser",
    exportPdf: "Télécharger le rapport",
    reportTitle: "Rapport d'analytique QR",
    peakDay: "Jour de pointe",
    generatedAt: "Généré le",
    pdfOk: "Rapport téléchargé",
    pdfErr: "Impossible de générer le rapport",
  },
  guests: {
    title: "Invités",
    titleCount: "Invités ({{count}})",
    phoneRequired: "Téléphone *",
    namePlaceholder: "Jean Dupont",
    importBtn: "Importer",
    exportBtn: "Exporter",
    jsonFormat: "Format JSON :",
    columnPhone: "Téléphone",
    columnName: "Nom",
    columnRsvp: "RSVP",
    columnHeadcount: "Nombre",
    columnDiet: "Régime",
    columnNotes: "Notes",
    columnEditedBy: "Modifié par",
    columnDate: "Date",
    dietNone: "Aucun",
    dietVegan: "Végan",
    dietVegetarian: "Végétarien",
    dietGlutenFree: "Sans gluten",
    dietOther: "Autre",
    deleteConfirm: 'Voulez-vous vraiment supprimer "{{name}}" ?',
    importSuccess: "{{imported}} invités ajoutés, {{skipped}} ignorés (total : {{total}})",
    importJsonError: "Le fichier JSON doit être un tableau ou au format { guests: [...] }",
    added: "Invité ajouté",
    deleted: "Invité supprimé",
    deleteNoMedia: "L'invité sera retiré de la liste. Il n'a envoyé aucun média.",
    deleteMediaKept: "L'invité sera retiré de la liste. Ses {{count}} média(s) RESTENT dans la galerie — cochez la case ci-dessous pour les supprimer aussi.",
    deleteMediaToo: "Supprimer aussi ses {{count}} média(s)",
    deleteMediaTooHint: "Les médias supprimés peuvent être restaurés depuis Modération → Supprimés pendant {{days}} jours, ensuite ils sont effacés définitivement.",
    saved: "Modifications enregistrées",
    exported: "{{count}} invités exportés",
    phoneHint: "Inclure l'indicatif pays — ex. +33612345678",
    phoneInvalid: "Numéro invalide — inclure l'indicatif pays (ex. +33...)",
    nameRequired: "Le nom est obligatoire",
    banGuest: "Bannir l'invité",
    smsConsentOn: "Consentement SMS activé — cliquer pour retirer",
    smsConsentOff: "Pas de consentement SMS — cliquer pour ajouter",
    smsOptedOut: "L'invité a refusé les SMS",
    smsConsentSet: "Consentement SMS ajouté",
    smsConsentUnset: "Consentement SMS retiré",
    banDuration1d: "1 Jour",
    banDuration7d: "7 Jours",
    banDuration30d: "30 Jours",
    banReasonPlaceholder: "Motif (optionnel)",
    banPermanent: "Permanent",
    banUntil: "Banni — jusqu'au {{date}}",
    banPermanentLabel: "Banni définitivement",
    unban: "Lever le ban",
    banned: "Banni",
    guestBanned: "Invité banni",
    guestUnbanned: "Ban levé",
    addGuest: "Ajouter un invité",
    editTitle: "Modifier l'invité",
    filterAll: "Tous",
    filterNone: "Sans RSVP",
    rsvpYes: "Confirmé",
    rsvpNo: "Décliné",
    rsvpMaybe: "Peut-être",
    rsvpYesCount: "{{count}} personnes",
    rsvpNoCount: "{{count}} déclinent",
    rsvpMaybeCount: "{{count}} peut-être",
    noGuests: "Aucun invité pour le moment",
    noGuestsSearch: "Aucun invité ne correspond à votre recherche",
    noName: "Sans nom",
    searchPlaceholder: "Rechercher par nom ou téléphone…",
    columnDetails: "Détails",
    headcountLabel: "{{count}} personnes",
    headcountMax: "Max {{max}}",
    headcountPerson: "personnes",
    timeMinutes: "{{count}}min",
    timeHours: "{{count}}h",
    timeDays: "{{count}}j",
    diet_vegan: "Végétalien",
    diet_vegetarian: "Végétarien",
    diet_gluten_free: "Sans gluten",
    diet_other: "Spécial",
  },
  moderation: {
    title: "Modération des Médias",
    titleCount: "Modération des Médias ({{count}} en attente)",
    noItems: "Aucun média en attente",
    approve: "Approuver",
    reject: "Rejeter",
    reviewedBy: "Vérifié par : {{email}}",
    history: "Historique",
    pending: "En attente",
    returnToPending: "Remettre en attente",
    autoRefreshOff: "Actualisation auto désactivée",
    refreshNow: "Actualiser",
    autoRefreshOn: "Actualisation auto activée ({{s}}s)",
    bulkApprove: "Approuver la sélection",
    bulkReject: "Rejeter la sélection",
    bulkApproved: "Éléments sélectionnés approuvés",
    bulkRejected: "Éléments sélectionnés rejetés",
    rejectDeleteHint: "Rejeté — le fichier sera définitivement supprimé dans 7 jours",
    bulkRejectedDeleteHint: "Rejetés — les fichiers seront définitivement supprimés dans 7 jours",
    deletesIn: "Supprimé dans {{days}}j",
    deletesInHours: "Supprimé dans {{hours}}h",
    deletesImminently: "Suppression imminente",
    selected: "{{count}} sélectionné(s)",
    selectAll: "Tout sélectionner",
    deselectAll: "Désélectionner tout",
    tabApproved: "Approuvés",
    tabRejected: "Rejetés",
    tabDeleted: "Supprimés",
    noDeleted: "Aucun média supprimé",
    deletedHint: "Ces éléments seront définitivement supprimés dans {{days}} jours. Appuyez sur Restaurer pour les récupérer.",
    restore: "Restaurer",
    guestRemovedLocked: "Retiré par l’invité",
    guestRemovedLockedHint: "L’invité a retiré ce contenu lui-même. La décision lui appartient : impossible de le restaurer ou de l’approuver ; il sera supprimé définitivement à la fin du délai.",
    restored: "Média restauré",
    guestDeleted: "invité supprimé",
    unknownGuest: "Invité inconnu",
  },
  wedding: {
    title: "Mariages",
    myWeddings: "Mes Mariages",
    newWedding: "Nouveau Mariage",
    createTitle: "Créer un Nouveau Mariage",
    slugPlaceholder: "Slug URL (ex : jean-marie)",
    titlePlaceholder: "Titre du mariage",
    datePlaceholder: "Date et heure",
    locationPlaceholder: "Lieu",
    created: "Mariage créé",
    createFailed: "Échec de la création du mariage",
    deleteConfirm: 'Voulez-vous vraiment supprimer "{{slug}}" ? Cette action est irréversible.',
    deleteFailed: "Échec de la suppression",
    deleteButton: "Supprimer le mariage",
    archiveConfirm: 'Voulez-vous vraiment archiver "{{slug}}" ? Il sera retiré de votre liste mais les données seront conservées. Il compte toujours dans votre limite de plan.',
    archived: "Mariage archivé",
    archiveFailed: "Échec de l'archivage",
    archiveButton: "Archiver le mariage",
    unarchived: "Mariage restauré",
    unarchiveFailed: "Échec de la restauration",
    unarchiveButton: "Restaurer le mariage",
    archivedSection: "Mariages archivés",
    archivedBadge: "Archivé",
    noWeddings: "Vous n'avez pas encore de mariage.",
    noWeddingsHint: 'Créez votre premier mariage avec le bouton "Nouveau Mariage" ci-dessus.',
    notFound: "Mariage Non Trouvé",
    noWeddingsAdmin: "Aucun mariage créé",
    owner: "Propriétaire",
    enterTitle: "Veuillez entrer un titre pour le mariage",
    enterDate: "Veuillez entrer la date et l'heure du mariage",
    enterLocation: "Veuillez entrer le lieu du mariage",
    descriptionPlaceholder: "Description (facultative)",
    infoTab: "Détails du Mariage",
    registrationTab: "Inscription",
    bgTab: "Arrière-plans",
    notificationsTab: "Notifications",
    slugReadOnly: "Le slug est permanent et ne peut pas être modifié",
    settingsHint: "Gérez les détails de votre mariage et les paramètres d'inscription.",
    updateSuccess: "Détails du mariage mis à jour",
    mainEventLabel: "Mariage",
    event2: {
      sectionTitle: "Deuxième événement",
      sectionHint: "Ajoutez un événement supplémentaire : soirée au henné, cérémonie civile ou after-party.",
      addButton: "Ajouter un deuxième événement",
      removeButton: "Supprimer",
      dateTimeLabel: "Date et heure",
      locationLabel: "Lieu",
      locationPlaceholder: "Nom du lieu ou adresse",
      labelLabel: "Type d'événement",
      customLabelPlaceholder: "Saisissez le nom de l'événement",
      dateRequired: "La date et l'heure sont obligatoires pour le deuxième événement",
      customLabelRequired: "Le nom de l'événement est obligatoire si « Autre » est sélectionné",
    },
    program: {
      programTitle: "Programme",
      daysLeft: "J-{{count}}",
      today: "AUJOURD'HUI",
      past: "TERMINÉ",
      tomorrow: "DEMAIN",
      mainEventTypeLabel: "Type de l'événement principal",
    },
    event2Label: {
      kina: "Soirée au henné",
      nikah: "Cérémonie civile",
      dugun: "Mariage",
      afterParty: "After-party",
      other: "Autre",
    },
    updateFailed: "Mise à jour échouée",
    eventDateLocked: "La date de l’événement est passée — elle ne peut plus être modifiée (une formule couvre un seul événement). Contactez le support pour une correction.",
    bgSectionTitle: "Images de fond",
    bgSlotAuth: "Fond de connexion invité",
    bgSlotCountdown: "Fond du compte à rebours",
    bgSlotRsvp: "Fond RSVP",
    bgUploaded: "Fond téléchargé",
    bgDeleted: "Fond supprimé",
    bgUploadFailed: "Échec du téléchargement",
    bgDeleteFailed: "Échec de la suppression",
    language: "Langue de l'Application Invités",
    languageHint: "Définit l'indicatif pays par défaut sur la page de connexion.",
    languageSaved: "Langue enregistrée",
    languageSaveFailed: "Échec de l'enregistrement",
    bride: "Mariée",
    groom: "Marié",
    enterBride: "Veuillez saisir le prénom de la mariée",
    enterGroom: "Veuillez saisir le prénom du marié",
    manage: "Gérer",
    slugAvailable: "Disponible",
    slugTaken: "Déjà utilisé",
    slugChecking: "Vérification...",
    slugInvalidFormat: "Invalide (min. 3 car., a-z 0-9 tirets seulement)",
    nameLettersOnly: "Lettres uniquement",
    locationInvalid: "Contient des caractères invalides",
    pkgWithGuests: "{{plan}} · jusqu’à {{n}} invités",
    pkgTrial: "{{plan}} (essai) · {{n}} invités",
    pkgAccountWide: "{{plan}} · tout le compte · {{n}} invités",
    createAccountWideNotice: "Ce mariage s'ouvre sans pack et utilise le forfait {{plan}} de votre compte (jusqu'à {{n}} invités).",
    applyTo: "Choisir un mariage",
    applyButton: "Attribuer à ce mariage",
    applied: "Formule attribuée à « {{title}} ».",
    applyFailed: "Impossible d’attribuer la formule, veuillez réessayer.",
    packageUnavailable: "Cette formule n’est plus disponible (elle est peut-être attribuée à un autre mariage). La liste a été actualisée.",
    packageForWedding: "Formule de ce mariage",
    packageChoiceHint: "Chaque formule vaut pour un seul mariage ; les limites du mariage sont celles de la formule choisie.",
    freeSlotsFull: "Vous n'avez aucune formule disponible. Achetez une formule pour un nouveau mariage.",
    createdWithPackage: "Mariage créé et formule attribuée.",
    pkgFree: "{{plan}} · {{n}} invités",
    pkgLegacy: "{{plan}} (transition) · {{n}} invités",
    pkgSuspended: "Aucune formule — mariage suspendu",
    walletAvailable: "Formules disponibles",
    walletNone: "Aucune",
    walletInUse: "Utilisées : {{n}}",
    walletPending: "En attente de paiement : {{n}}",
    walletLink: "Mes formules →",
    buyPackage: "Acheter une formule",
    noPackageHint: "Vous n'avez aucune formule disponible pour un nouveau mariage. Achetez-en une ; elle apparaît ici une fois le paiement confirmé.",
    packagePendingOption: "{{pkg}} · {{number}} — paiement en attente",
    createFreeNotice: "Ce mariage s'ouvre avec la formule {{plan}} (jusqu'à {{n}} invités). Vous pourrez l'améliorer plus tard en attribuant une formule payante ; la formule Free est alors consommée.",
    startConsent: "J'accepte que le service commence immédiatement, avant la fin du délai de rétractation, et je reconnais ne plus avoir de droit de rétractation une fois la formule attribuée à ce mariage.",
    packageRequired: "Choisissez une formule pour ce mariage.",
    consentRequired: "Cochez la case de consentement pour une formule payante.",
    upgradeTitle: "Attribuez une formule disponible à un mariage",
    upgradeHint: "Une formule payante améliore un mariage en formule Free ou de transition (la formule Free est alors consommée). Pour la modifier après attribution, contactez le support.",
    alreadyPaid: "Ce mariage a déjà une formule payante.",
    weddingHasPackage: "La formule Free ne peut être attribuée qu'à un mariage sans formule (suspendu).",
  },
  profile: {
    title: "Mon Profil",
    emailLabel: "E-mail",
    nameLabel: "Nom Complet",
    phoneLabel: "Téléphone",
    phoneLocked: "Contactez le support pour modifier votre numéro de téléphone.",
    memberSince: "Membre depuis {{date}}",
    loadFailed: "Échec du chargement du profil",
    updateSuccess: "Profil mis à jour",
    updateFailed: "Échec de la mise à jour",
    deactivateTitle: "Désactiver le compte",
    deactivateDesc: "Votre compte sera suspendu. Il se réactive automatiquement à la prochaine connexion OTP.",
    deactivateConfirm: "Oui, désactiver",
    deactivateSuccess: "Compte désactivé. Redirection en cours...",
    deactivateFailed: "Échec de la désactivation du compte",
    dangerZone: "Zone dangereuse",
    accountInfo: "Informations du compte",
    phoneChangeTitle: "Changement de numéro de téléphone",
    phoneChangeAction: "Modifier",
    phoneVerified: "Vérifié",
    phoneNotVerified: "Non vérifié (requis pour le SMS test)",
    phoneVerifyAction: "Vérifier",
    phoneVerifyTitle: "Vérifier le téléphone",
    phoneVerifyInfo: "Saisissez le code à 6 chiffres envoyé au {{phone}}.",
    phoneVerifyResend: "Renvoyer",
    phoneVerifySubmit: "Vérifier",
    phoneVerifySuccess: "Téléphone vérifié",
    phoneChangeInfo: "Une demande sera créée pour changer votre numéro. Notre équipe la traitera dès que possible.",
    phoneChangeSubject: "Demande de changement de numéro de téléphone",
    phoneCurrent: "Actuel",
    phoneChangeNew: "Nouveau",
    phoneNone: "Aucun",
    phoneChangeAutoNote: "Cette demande a été créée automatiquement depuis la page de profil.",
    phoneChangeSubmit: "Envoyer la demande",
    phoneChangeSuccess: "Demande envoyée",
    phoneChangeSuccessDesc: "Notre équipe vérifiera et mettra à jour votre numéro prochainement.",
    phoneChangeViewTicket: "Voir le ticket",
    phoneChangeFailed: "Échec de l'envoi de la demande",
    phoneChangeRequired: "Veuillez saisir un nouveau numéro",
    phoneChangeFormat: "Le numéro doit commencer par l'indicatif pays (ex. +33612345678)",
    phoneChangeSame: "Le nouveau numéro est identique au numéro actuel",
    accountPackages: "Compte et formules",
    packagesExplain: "Chaque mariage est lié à une formule. Votre compte dispose d'une formule Free ; chaque commande payée est une nouvelle formule. Vos formules et l'historique des commandes sont dans Mes formules.",
    accountWideBadge: "Tout le compte : {{plan}}",
    accountWideTitle: "Forfait du compte",
    accountWideExplain: "Le forfait {{plan}} propre à votre compte s'applique aux mariages sans pack attribué. Les packs payés valent pour un seul mariage et en fixent les limites.",
    orderLegacy: "Transition (ancien forfait de compte)",
    myOrders: "Mes commandes",
    noOrders: "Aucune commande pour l’instant.",
    orderPkg: "{{plan}} · jusqu’à {{n}} invités",
    orderWedding: "Mariage : {{title}}",
    orderCancelled: "Annulée",
    orderStatus: {
      pending: "Paiement en attente",
      paid: "Payée",
      cancelled: "Annulée",
    },
    buyPackage: "Acheter une formule pour un nouveau mariage",
    freeTitle: "Formule Free",
    freeStatus: {
      available: "Disponible — vous pouvez créer un mariage",
      assigned: "Utilisée : {{title}}",
      ended: "Consommée — le mariage est passé à une formule payante",
      used: "Utilisée",
    },
    packagesLink: "Mes formules",
  },
  rsvp: {
    title: "RSVP",
    welcomeGuest: "Bienvenue, {{name}}",
    shareStatus: "Dites-nous si vous serez présent",
    formTitle: "Formulaire de Participation",
    formDescUpdate: "Vous pouvez mettre à jour vos informations",
    formDescNew: "Veuillez remplir vos informations",
    statusLabel: "Statut de Participation",
    statusYes: "Je participe",
    statusMaybe: "Peut-être",
    statusNo: "Je ne peux pas",
    headcountLabel: "Nombre de Personnes",
    decreaseHeadcount: "Diminuer le nombre d'invités",
    increaseHeadcount: "Augmenter le nombre d'invités",
    dietLabel: "Préférence Alimentaire",
    dietNone: "Aucune restriction",
    dietVegan: "Végan",
    dietVegetarian: "Végétarien",
    dietGlutenFree: "Sans gluten",
    dietOther: "Autre",
    notesLabel: "Notes (optionnel)",
    notesPlaceholder: "Un message à partager...",
    submitting: "Envoi...",
    saved: "Enregistré !",
    update: "Mettre à jour",
    submit: "Envoyer",
    successUpdate: "Votre réponse a été mise à jour !",
    successNew: "Votre réponse a été envoyée !",
    thanks: "Merci",
  },
  media: {
    uploadTitle: "Télécharger Photo / Vidéo",
    uploadDesc: "Partagez vos souvenirs avec nous",
    heicLocationNote: "La position est supprimée des photos avant l’envoi, mais ce n’est pas possible pour les photos HEIC. Si vous ne voulez pas partager votre position, choisissez la photo en JPEG ou désactivez la localisation de l’appareil photo.",
    uploadCard: "Télécharger un Média",
    supportedFormats: "Fichiers JPEG, PNG, HEIC, MP4, MOV acceptés",
    selectFile: "Sélectionnez un fichier ou prenez une photo",
    preview: "Aperçu",
    uploadBtn: "Télécharger",
    unsupportedType: "Type de fichier non pris en charge",
    fileTooLarge: "Fichier trop volumineux (max {{max}} Mo)",
    uploadFailed: "Échec du téléchargement",
    uploadPartialError: "Certains fichiers n'ont pas pu être téléchargés.",
    errorTooLarge: "{{name}} est trop volumineux (max {{limit}} Mo)",
    errorUnsupportedType: "{{name}} n'est pas pris en charge (JPEG, PNG, HEIC, MP4, MOV)",
    videoLongWarning: "{{name}} dure environ {{duration}}s — les vidéos longues peuvent avoir du mal à se téléverser sur une connexion faible, il est recommandé de la raccourcir.",
    retryFailed: "Réessayer",
    dropzoneDesc: "JPEG, PNG, HEIC, MP4, MOV acceptés",
    dropzone: "Sélectionnez un fichier ou prenez une photo",
    uploading: "Téléchargement... ({{progress}}%)",
    uploadSuccess: "Téléchargé ! Sera visible après modération.",
    moderationNotice: "Vos téléchargements seront examinés avant d'apparaître dans la galerie.",
    uploadTips: "Conseils",
    tip1: "Capturez des moments spontanés de la cérémonie",
    tip2: "Des clips courts de 10 à 15 secondes sont idéaux",
    tip3: "Les photos haute qualité sont préférées",
    submitBtn: "Envoyer à la galerie ({{count}})",
    noFilesSelected: "Aucun fichier sélectionné",
    clearAll: "Tout effacer",
    addMore: "Ajouter des fichiers",
    filesSelected: "Sélectionnés ({{count}})",
    mine: {
      title: "Mes envois ({{count}})",
      hint: "Vous pouvez retirer ici tout ce que vous avez envoyé — c’est retiré aussitôt, l’organisateur ne peut pas le rétablir, et c’est supprimé définitivement sous 7 jours.",
      pending: "En attente de validation",
      approved: "Dans la galerie",
      delete: "Supprimer",
      deleteConfirm: "Retirer ce contenu ? Il disparaît aussitôt de la galerie et de l’écran de la salle, l’organisateur ne peut pas le rétablir ; il est supprimé définitivement sous 7 jours.",
      deleted: "Supprimé",
      deleteFailed: "Suppression impossible : {{error}}",
    },
  },
  gallery: {
    title: "Galerie",
    subtitle: "Souvenirs partagés",
    empty: "Aucun média partagé",
    emptyHint: "Soyez le premier à télécharger une photo !",
    selectedCount: "{{count}} sélectionné(s)",
    swipeHint: "Balayez pour naviguer",
    prev: "Précédent",
    next: "Suivant",
    close: "Fermer",
    allMedia: "Médias approuvés",
    favorites: "Favoris",
    reviewQueue: "File d'attente",
    recycle: "Rejetés",
    newAlbum: "Nouvel album",
    albumName: "Nom de l'album",
    createAlbum: "Créer l'album",
    deleteAlbum: "Supprimer l'album",
    deleteAlbumConfirm: "Voulez-vous vraiment supprimer cet album ? Les médias ne seront pas supprimés.",
    renameAlbum: "Renommer",
    addToAlbum: "Ajouter à l'album",
    removeFromAlbum: "Retirer de l'album",
    setCover: "Définir comme couverture",
    selectMode: "Sélectionner",
    cancelSelect: "Annuler la sélection",
    selected: "{{count}} sélectionné(s)",
    albumLimitReached: "Vous pouvez créer au maximum 5 albums personnalisés.",
    onlyApprovedCanBeAdded: "Seuls les médias approuvés peuvent être ajoutés aux albums.",
    noMedia: "Aucun média pour l'instant.",
    noAlbumMedia: "Aucun média dans cet album.",
    loadMore: "Charger plus",
    itemCount: "{{count}} éléments",
    addedToFavorites: "Ajouté aux favoris",
    removedFromFavorites: "Retiré des favoris",
    addedToAlbum: "Ajouté à l'album",
    removedFromAlbum: "Retiré de l'album",
    albumCreated: "Album créé",
    albumDeleted: "Album supprimé",
    albumRenamed: "Album renommé",
    coverSet: "Photo de couverture mise à jour",
    like: "J'aime",
    unlike: "Je n'aime plus",
    liked: "J'aime !",
    commentAdded: "Commentaire ajouté",
    commentDeleted: "Commentaire supprimé",
    deleteComment: "Supprimer le commentaire",
    noComments: "Aucun commentaire",
    commentPlaceholder: "Ajouter un commentaire...",
    share: "Partager",
    viewAllComments: "Voir les {{count}} commentaires",
    likesCount: "{{count}} j'aime",
    guest: "Invité",
    doubleTapToLike: "Double tap pour aimer",
    uploadPhotos: "Télécharger",
    searchByName: "Rechercher par nom d'invité...",
    filterNewest: "Plus récent",
    filterOldest: "Plus ancien",
    download: "Télécharger",
    commentsCount: "{{count}} commentaires",
    uploadedBy: "Téléchargé par {{name}}",
    noResults: "Aucun résultat",
    noResultsHint: "Essayez un autre terme de recherche",
    albums: "Albums",
    noAlbums: "Aucun album",
    noPublicAlbums: "Aucun album partagé",
    noPublicAlbumsHint: "L'organisateur n'a pas encore publié d'albums",
    backToAlbums: "Retour aux albums",
    makePublic: "Rendre public",
    makePrivate: "Rendre privé",
    filterAll: "Tous",
    filterPhotos: "Photos",
    filterVideos: "Vidéos",
    manageAlbums: "Gérer les albums",
    editAlbum: "Modifier l'album",
    hideComment: "Masquer le commentaire",
    unhideComment: "Afficher le commentaire",
    commentHidden: "Masqué",
    commentHiddenSuccess: "Commentaire masqué",
    commentUnhiddenSuccess: "Commentaire visible",
    visibility: "Visibilité",
    coverPhoto: "Photo de couverture",
    public: "Public",
    private: "Privé",
    albumSaved: "Album enregistré",
    addFromGallery: "Ajouter depuis la galerie",
    addSelected: "Ajouter la sélection ({{count}})",
    alreadyInAlbum: "Déjà dans l'album",
    removeFromAlbumConfirm: "Retirer ?",
    searchGuest: "Rechercher un invité...",
  },

  // ─── Activity Feed ──────────────────────────────
  activity: {
    title: "Activité",
    all: "Tout",
    reactions: "Réactions",
    uploads: "Publications",
    likedOne: "a aimé une photo",
    likedOne_video: "a aimé une vidéo",
    likedMany: "a aimé {{count}} photos",
    likedMany_video: "a aimé {{count}} vidéos",
    commentedOne: "a laissé un commentaire",
    commentedMany: "a laissé {{count}} commentaires",
    uploadedOne: "a publié une photo",
    uploadedOne_video: "a publié une vidéo",
    uploadedMany: "a publié {{count}} photos",
    uploadedMany_video: "a publié {{count}} vidéos",
    pendingOne: "1 photo en attente d'approbation",
    pendingMany: "{{count}} photos en attente d'approbation",
    newActivity: "{{count}} nouvelles activités",
    empty: "Pas encore d'activité",
    emptyHint: "Soyez le premier à publier une photo !",
    justNow: "à l'instant",
    minutesAgo: "il y a {{count}}min",
    hoursAgo: "il y a {{count}}h",
    daysAgo: "il y a {{count}}j",
    you: "Vous",
    uploaded: "a téléchargé une photo",
    uploaded_video: "a téléchargé une vidéo",
    liked: "a aimé une photo",
    liked_video: "a aimé une vidéo",
    commented: "a commenté",
    youUploadedOne: "avez téléchargé une photo",
    youUploadedOne_video: "avez téléchargé une vidéo",
    youUploadedMany: "avez téléchargé {{count}} photos",
    youUploadedMany_video: "avez téléchargé {{count}} vidéos",
    youLikedOne: "avez aimé une photo",
    youLikedOne_video: "avez aimé une vidéo",
    youLikedMany: "avez aimé {{count}} photos",
    youLikedMany_video: "avez aimé {{count}} vidéos",
    youCommentedOne: "avez commenté",
    youCommentedMany: "avez laissé {{count}} commentaires",
    unknownGuest: "Invité",
    galleryBanner: "{{count}} nouvelles activités ↑",
    galleryBannerTap: "Appuyez pour voir",
    toast: {
      newUpload: "{{name}} a téléchargé une photo 📸",
      newUpload_video: "{{name}} a téléchargé une vidéo 🎥",
      newLike: "{{name}} a aimé une photo ❤️",
      newLike_video: "{{name}} a aimé une vidéo ❤️",
      newComment: "{{name}} a commenté 💬",
      see: "Voir →",
    },
  },
  slideshow: {
    title: "Scène",
    live: "En direct",
    connecting: "Connexion...",
    waiting: "En attente de la scène...",
    waitingHint: "Les photos approuvées apparaîtront ici",
    sharedBy: "Partagé par {{name}}",
    memoriesInSync: "Souvenirs en direct",
    fullscreen: "Plein écran",
    exit: "Quitter",
    exitFullscreen: "Réduire",
    mute: "Muet",
    unmute: "Activer",
    scanToJoin: "Rejoignez la fête",
    scanToJoinHint: "Scannez pour partager des photos & envoyer de l'amour",
    tapToReact: "Envoyez un ❤️ depuis votre téléphone",
    reactedOne: "{{name}} a réagi",
    reactedOther: "{{name}} +{{count}} ont réagi",
    idleHint: "Scannez le code pour partager votre premier souvenir",
    watching: "regardent",
    presenceTitle: "Spectateurs",
    presenceMore: "+{{count}} de plus",
    joined: "{{name}} a rejoint",
    rejiLive: "Reji en direct",
    guestFallbackName: "Invité",
  },
  slideshowRemote: {
    playing: "Lecture en cours",
    paused: "En pause",
    slideOf: "{{current}} / {{total}}",
    viewers: "{{count}} spectateurs",
    pause: "Pause",
    resume: "Reprendre",
    next: "Suivant",
    previous: "Précédent",
    controlSuccess: "Commande envoyée",
    controlFailed: "Échec de la commande",
    offline: "Scène hors ligne",
  },
  reji: {
    title: "Reji",
    subtitle: "Cabine de régie",
    live: "EN DIRECT",
    idleNoViewers: "En attente de spectateurs — scène en pause",
    connecting: "Connexion...",
    watchMode: "Rejoindre la scène",
    exitWatch: "Retour à la régie",
    flow: "Flux",
    nowPlaying: "Sur scène",
    nextUp: "À suivre",
    hidden: "Masqué",
    hide: "Masquer",
    unhide: "Rétablir",
    spotlight: "Mettre en avant",
    gotoSuccess: "Diapositive affichée",
    hideSuccess: "Masqué du spectacle",
    unhideSuccess: "Rétabli dans le spectacle",
    spotlightSuccess: "Mis en avant — à suivre",
    orderFirst: "Mettre en tête",
    moveNext: "Lire ensuite",
    moveEnd: "Mettre à la fin",
    nudgeUp: "Monter",
    nudgeDown: "Descendre",
    presenceSheetTitle: "Spectateurs",
    roleGuest: "Invité",
    roleReji: "Reji",
    emptyPlaylist: "Aucun média approuvé",
    openReji: "Ouvrir Reji",
    dashboardStatus: "État de la scène",
  },
  admin: {
    watchSahne: "Voir la Sahne",
    beVisible: "Être visible",
    watchHidden: "Vue masquée",
    watchOnly: "Lecture seule",
    presenceName: "Administrateur",
    forbidden: "Accès Refusé",
    forbiddenDesc: "n'est pas enregistré comme administrateur de plateforme.",
    forbiddenHelp: "Contactez un administrateur de plateforme pour obtenir l'accès.",
    switchAccount: "Se connecter avec un autre compte",
    backToWeddings: "Retour à Tous les Mariages",
    usersTitle: "Utilisateurs (Organisateurs)",
    usersDesc: "Gérez les organisateurs et les forfaits de la plateforme",
    weddingsDesc: "Gérez et suivez tous les mariages de la plateforme",
    packageColumn: "Pack",
    packageAccountWide: "tout le compte",
    packageTrial: "Essai",
    packageFree: "Formule Free",
    packageLegacy: "transition",
    packageSuspended: "Suspendu (aucune formule)",
    accountPlanShort: "Compte : {{plan}}",
    accountPlanTitle: "Forfait du compte de l'organisateur — s'applique uniquement aux mariages sans pack ; le pack de ce mariage figure sur la carte du tableau de bord",
    usersTotal: "{{count}} organisateurs au total",
    usersEmpty: "Aucun utilisateur enregistré.",
    usersLoadFailed: "Échec du chargement des utilisateurs",
    planUpdateFailed: "Échec de la mise à jour du forfait",
    columnPlan: "Forfait",
    columnWeddings: "Mariages",
    columnRegistered: "Inscrit",
    userDetail: "Détail Utilisateur",
    userWeddings: "Mariages de l'Utilisateur",
    noUserWeddings: "Cet utilisateur n'a pas de mariage.",
    organizersTitle: "Organisateurs",
    organizersEmpty: "Aucun organisateur assigné à ce mariage.",
    organizerRole: "Rôle",
    organizerAccessHint: "Organisateurs ayant accès à ce mariage",
    addOrganizer: "Ajouter un organisateur",
    addFirstOrganizer: "Ajouter le premier organisateur",
    organizerAdded: "Organisateur ajouté",
    organizerRemoved: "Organisateur supprimé",
    removeOrganizer: "Supprimer l'organisateur",
    removeOrganizerConfirm: "êtes-vous sûr de vouloir supprimer l'accès de cet organisateur ?",
    // ─── Plans management ───────────────────────────
    plans: "Forfaits",
    addPlan: "Nouveau Forfait",
    auditLog: "Journal d'Audit",
    planDeleteConfirm: 'Voulez-vous vraiment supprimer "{{slug}}" ?',
    planFieldSlug: "Slug",
    planFieldLabel: "Étiquette",
    planFieldSortOrder: "Ordre",
    planFieldDefault: "Par défaut",
    planFieldMaxWeddings: "Max Mariages",
    planFieldMaxGuests: "Max Invités",
    planFieldMaxStorage: "Max Stockage (Go)",
    planFieldMaxMedia: "Max Médias",
    planColLabel: "Étiquette",
    planColSlug: "Slug",
    planColWeddings: "Mariages",
    planColGuests: "Invités",
    planColStorage: "Stockage",
    planColMedia: "Médias",
    planColUsers: "Utilisateurs",
    planColStatus: "Statut",
    planStatusDefault: "Par défaut",
    planStatusActive: "Actif",
    planStatusInactive: "Inactif",
    planHistory: "Historique",
    planChangeHistory: "Historique des Modifications",
    planNoHistory: "Aucun historique de modifications",
    // ─── Audit log ──────────────────────────────────
    timeJustNow: "à l'instant",
    timeMinutesAgo: "il y a {{count}} min",
    timeHoursAgo: "il y a {{count}} h",
    timeDaysAgo: "il y a {{count}} jour(s)",
    auditDescription: "Toutes les opérations d'écriture sur la plateforme",
    auditFilterAction: "Filtrer l'action",
    auditSearchAction: "Rechercher des actions…",
    auditRecordCount: "{{count}} entrées",
    auditTimeJustNow: "à l'instant",
    auditTimeMinutes: "il y a {{count}}min",
    auditTimeHours: "il y a {{count}}h",
    auditTimeDays: "il y a {{count}}j",
    auditActorAll: "Tous les Acteurs",
    auditActorAdmin: "Admin",
    auditActorOrganizer: "Organisateur",
    auditActorGuest: "Invité",
    auditActorSystem: "Système",
    auditActionsAll: "Toutes les Actions",
    auditSearchPlaceholder: "Rechercher nom, e-mail ou ID...",
    auditNoResults: "Aucun enregistrement trouvé",
    auditColTime: "Heure",
    auditColActor: "Acteur",
    auditColIdentity: "Identité",
    auditColAction: "Action",
    auditColResource: "Ressource",
    auditColWeddingId: "ID Mariage",
    auditGuestPrefix: "Invité",
    auditLoadMore: "Charger Plus",
    auditMetadata: "Métadonnées",
    auditMetadataNone: "Aucune métadonnée disponible pour cet enregistrement.",
  },
  web: {
    notFound: "Mariage Non Trouvé",
    weddingNotFound: "Mariage Non Trouvé",
    notFoundDesc: "La page de mariage que vous cherchez n'existe pas. Veuillez vérifier votre lien d'invitation.",
    invalidSlug: "Veuillez utiliser votre lien d'invitation pour accéder.",
    useLinkPrompt: "Veuillez utiliser votre lien d'invitation pour accéder.",
    appTitle: "Vite Gallery",
    notifications: "Notifications",
  },

  // ─── QR Self-Registration (Guest) ──────────────────
  join: {
    title: "Inscription au Mariage",
    subtitle: "Entrez vos informations pour rejoindre le mariage",
    namePlaceholder: "Nom Prénom",
    nameLabel: "Nom Prénom",
    submit: "S'inscrire",
    submitting: "Inscription...",
    smsConsentLabel: "Je souhaite recevoir les SMS d'invitation et de rappel du mariage. (Vous pouvez vous désinscrire à tout moment via le lien du message.)",
    alreadyRegistered: "Vous êtes déjà inscrit !",
    alreadyRegisteredHint: "Ce numéro est déjà associé à ce mariage. Appuyez sur le bouton ci-dessous pour vous connecter.",
    goToLogin: "Se connecter",
    registrationClosed: "Inscription fermée",
    registrationClosedHint: "L'inscription des invités n'est pas active pour ce mariage",
    registrationNotYet: "Inscription pas encore ouverte",
    registrationOpensWeddingDay: "Sera active le jour du mariage",
    countdownDays: "jours",
    countdownHours: "h",
    countdownMinutes: "min",
    countdownSeconds: "sec",
    successOtp: "Un code de vérification a été envoyé sur votre téléphone",
    successAuthed: "Inscription terminée !",
    capReached: "Inscriptions temporairement suspendues",
    capReachedHint: "La limite d'inscriptions du jour est atteinte. Réessayez plus tard ou contactez les mariés.",
    guestLimitReached: "Nombre d’invités atteint",
    guestLimitReachedHint: "Le nombre d’invités de ce mariage est atteint. Prévenez les mariés : ils peuvent l’augmenter. Si vous êtes sur la liste, connectez-vous avec votre téléphone.",
    foreignNumber: "Ce numéro ne peut pas être enregistré.",
    foreignNumberHint: "Le SMS de vérification ne peut être envoyé qu'aux numéros commençant par {{prefixes}}. Contactez les mariés pour être ajouté à la liste.",
    invalidName: "Veuillez saisir vos nom et prénom — au moins 2 lettres, sans chiffres ni liens.",
  },

  // ─── Registration Settings (Organizer) ─────────────
  registration: {
    title: "Paramètres d'inscription",
    allowSelfRegister: "Auto-inscription",
    allowSelfRegisterHint: "Les invités peuvent s'inscrire en scannant le QR code",
    requireOtp: "Vérification OTP",
    requireOtpHint: "Si désactivé, le numéro de téléphone suffit sans code de vérification",
    closedMode: "Fermé définitivement",
    closedModeHint: "Les invités ne peuvent pas s'inscrire",
    scheduledMode: "Ouverture planifiée",
    opensAt: "Ouverture des inscriptions",
    opensAtHint: "Les inscriptions s'ouvriront automatiquement à cette date et heure",
    opensAtRequired: "Veuillez sélectionner une date et heure d'ouverture",
    useWeddingTime: "Utiliser l'heure du mariage",
    closesAt: "Clôture des inscriptions",
    closesAtHint: "Passé cette date, le lien QR n'accepte plus d'inscriptions. Laissez vide pour le garder ouvert.",
    closesAtClear: "Effacer",
    closesAtBeforeOpens: "La clôture doit être postérieure à l'ouverture",
    closesAtWeekAfterWedding: "1 semaine après le mariage",
    incentiveTextPlaceholder: "Nous avons besoin de votre numéro de téléphone afin de pouvoir partager les photos avec vous après le mariage",
    save: "Enregistrer",
    saving: "Enregistrement...",
    saved: "Paramètres sauvegardés",
    saveFailed: "Échec de la sauvegarde",
    qrCode: "QR Code",
    qrCodeHint: "Les invités scannent ce QR code pour s'inscrire",
    qrDownload: "Télécharger PNG",
    qrDownloadSvg: "Télécharger SVG",
    qrDownloadPdf: "Télécharger PDF",
    qrCtaShare: "Partagez vos photos",
    qrCopyUrl: "Copier l'URL",
    qrCopied: "Copié !",
    sourceOrganizer: "Ajouté manuellement",
    sourceQr: "Rejoint via QR",
    weddingDetails: "Détails du mariage",
    weddingDetailsHint: "Contrôlez les champs que les invités peuvent remplir lors du RSVP",
    showDietField: "Préférence alimentaire",
    showDietFieldHint: "Collectez les restrictions alimentaires des invités",
    showNotesField: "Demandes spéciales",
    showNotesFieldHint: "Permettre aux invités d'ajouter une note",
    maxHeadcount: "Personnes par RSVP",
    maxHeadcountHint: "Nombre maximum de personnes par réponse RSVP",
  },

  // ─── Support Tickets ───────────────────────────────
  support: {
    title: "Tickets de Support",
    newTicket: "Ouvrir un Ticket",
    subject: "Sujet",
    body: "Description",
    status: "Statut",

    noTickets: "Aucun ticket de support pour l'instant.",
    selectTicket: "Sélectionnez un ticket",
    selectTicketHint: "ou ouvrez une nouvelle demande d'assistance",
    statusOpen: "Ouvert",
    statusInReview: "En cours",
    statusResolved: "Résolu",
    statusClosed: "Fermé",
    submit: "Envoyer",
    submitting: "Envoi...",
    successCreate: "Votre ticket de support a été soumis.",
    settingsSaved: "Enregistré",
    backToList: "Retour aux tickets",
    weddingLabel: "Mariage concerné",
    generalTicket: "Général (non lié à un mariage)",
    minCharsSubject: "Le sujet doit contenir au moins 5 caractères",
    minCharsBody: "La description doit contenir au moins 20 caractères",
    replyPlaceholder: "Écrivez votre message...",
    sendMessage: "Envoyer",
    sending: "Envoi...",
    ticketClosed: "Ce ticket est fermé, aucun nouveau message ne peut être envoyé.",
    you: "Vous",
    admin: "Équipe support",
    unreadDot: "Nouveau message",
    priorityLow: "Faible",
    priorityNormal: "Normal",
    priorityHigh: "Élevé",
    priorityUrgent: "Urgent",
    categoryGeneral: "Général",
    categoryBilling: "Facturation",
    categoryTechnical: "Technique",
    categoryBug: "Rapport de bug",
    categoryFeatureRequest: "Demande de fonctionnalité",
    priority: "Priorité",
    category: "Catégorie",
    internalNote: "Note interne",
    internalNoteHint: "Cette note est uniquement visible par l'équipe admin, pas par l'organisateur.",
    sendAndResolve: "Envoyer et résoudre",
    reopen: "Rouvrir",
    reopenConfirm: "Ce ticket va être rouvert. Êtes-vous sûr ?",
    csatTitle: "Évaluez votre expérience de support",
    csatHint: "Ce ticket est résolu. Vous pouvez évaluer votre expérience de 1 à 5.",
    csatSubmit: "Soumettre",
    csatThanks: "Merci pour votre retour !",
    csatAlreadyRated: "Vous avez déjà évalué ce ticket.",
    cannedResponses: "Réponses prédéfinies",
    cannedResponsesEmpty: "Aucune réponse prédéfinie.",
    addCannedResponse: "Ajouter une réponse",
    cannedTitle: "Titre",
    cannedContent: "Contenu",
    deleteCannedConfirm: "Cette réponse sera supprimée. Êtes-vous sûr ?",
    insertCanned: "Insérer une réponse prédéfinie",
    attachments: "Pièces jointes",
    attachmentHint: "Jusqu'à 2 photos, max 5 Mo chacune (JPEG, PNG, WebP, GIF)",
    attachmentUploading: "Chargement...",
    attachmentError: "Échec du téléchargement",
    removeAttachment: "Supprimer la pièce jointe",
    ticketNumber: "Ticket #{{number}}",
    sendNotification: "Envoyer la notification",
    noNotification: "Sans notification",
    monthlyLimitReached: "Vous avez atteint la limite mensuelle de tickets (max 10/mois).",
    csatRated: "Notés",
    csatUnrated: "En attente de note",
    tabActive: "Actif",
    tabResolved: "Résolu",
    attachFiles: "Joindre des fichiers",
    fileTypeError: "Seuls les fichiers JPEG, PNG, WebP et GIF sont acceptés.",
    fileSizeError: "Chaque fichier ne peut pas dépasser 5 Mo.",
  },
  adminSupport: {
    title: "Tickets de Support",
    settings: "Paramètres Support",
    allTickets: "Tous les Tickets",
    noTickets: "Aucun ticket de support.",
    from: "De",
    replyPlaceholder: "Écrivez votre réponse...",
    saveReply: "Enregistrer la réponse",
    saving: "Enregistrement...",
    updateStatus: "Mettre à jour le statut",
    settingsTitle: "Configuration Support",
    emailLabel: "Adresse e-mail de notification",
    sendMessage: "Envoyer",
    sending: "Envoi...",
    unreadDot: "Nouveau message",
  },
  sms: {
    title: "Invitations SMS",
    description: "Envoyez des SMS d'invitation et de rappel RSVP à vos invités",
    quotaLabel: "Envois restants",
    quotaExhausted: "Plus d'envois disponibles",
    smsQuotaLabel: "Crédits SMS restants",
    smsQuotaExhausted: "Plus de crédits SMS disponibles",
    channelDisabled: "L'envoi de SMS a été temporairement désactivé par l'administrateur. Vos campagnes planifiées seront envoyées automatiquement dès la réactivation du canal.",
    campaignsDisabled: "Les campagnes SMS n'ont pas encore été activées par l'administrateur. Vos campagnes planifiées seront envoyées automatiquement une fois activées.",
    sendDisabledHint: "L'envoi de SMS est désactivé par l'administrateur — l'envoi est impossible.",
    newCampaign: "Nouvelle campagne",
    nameLabel: "Nom de la campagne",
    namePlaceholder: "ex. Première invitation",
    templateLabel: "Modèle de message",
    defaultTemplate: "Cher/Chère {{guest_name}}, nous serions ravis de vous compter parmi nous au mariage de {{couple_names}} le {{date}}. Confirmez ici : {{rsvp_link}}",
    previewLabel: "Aperçu",
    previewEmpty: "Votre message apparaîtra ici",
    sampleGuest: "Marie Dupont",
    segmentInfo: "{{chars}} caractères · {{segments}} segment(s) SMS",
    ucs2Hint: "(les caractères spéciaux réduisent chaque segment à 70 caractères)",
    segmentLabel: "Qui le reçoit ?",
    segments: {
      all: "Tous les invités",
      rsvp_none: "Sans RSVP",
      rsvp_no: "Ont décliné",
      rsvp_maybe: "Indécis",
      manual: "Choisir manuellement",
    },
    recipientCount: "{{count}} destinataire(s)",
    searchGuests: "Rechercher un invité…",
    selectedCount: "{{count}} sélectionné(s)",
    noGuests: "Aucun invité trouvé",
    scheduleLabel: "Quand est-il envoyé ?",
    schedules: {
      now: "Envoyer maintenant",
      scheduled: "Planifier",
      auto_chain: "Rappel automatique",
    },
    scheduledAtLabel: "Heure d'envoi",
    chainDaysLabel: "Jours d'intervalle",
    chainRoundsLabel: "Tours max",
    chainHint: "Chaque tour ne vise que les invités sans RSVP ; quiconque répond sort automatiquement de la chaîne.",
    testPhonePlaceholder: "+33…",
    sendTest: "Envoyer un test",
    testHint: "Envoyé à votre numéro vérifié (vérifiez-le dans Profil).",
    testDisabledAdminHint: "Les administrateurs n'ont pas de numéro de téléphone vérifié enregistré — l'envoi de test n'est pas disponible ici.",
    goToControlCenter: "Aller au centre de contrôle",
    excludedNoConsent: "{{count}} sans consentement",
    testSent: "SMS de test envoyé",
    costEstimate: "Coût estimé : ~${{cost}}",
    submitNow: "Envoyer",
    submitSchedule: "Planifier",
    created: "Campagne créée",
    canceled: "Campagne annulée",
    delete: "Supprimer",
    deleteConfirm: "Cette campagne sera définitivement supprimée. Êtes-vous sûr ?",
    deleted: "Campagne supprimée",
    cancel: "Annuler",
    details: "Détails",
    history: "Historique des campagnes",
    noCampaigns: "Aucune campagne. Envoyez votre première invitation ci-dessus.",
    roundsUsed: "{{count}} tour(s)",
    nextRound: "prochain : {{date}}",
    held: "En attente",
    holdBadge: "En attente",
    holdReasons: {
      channel_disabled: "En attente car un administrateur a temporairement désactivé l'envoi de SMS. L'envoi reprendra automatiquement dès la réactivation.",
      campaigns_disabled: "En attente car les campagnes SMS n'ont pas encore été activées par un administrateur. L'envoi se fera automatiquement une fois activées.",
      not_configured: "En attente car l'envoi de SMS n'est pas encore configuré — veuillez contacter un administrateur.",
      spend_breaker: "En attente car une limite de dépenses de sécurité s'est déclenchée. L'envoi reprendra dès qu'un administrateur l'aura réinitialisée.",
      daily_cap: "En attente car la limite d'envoi quotidienne a été atteinte. L'envoi reprendra automatiquement après la réinitialisation.",
    },
    approval: {
      pendingBadge: "En attente d'approbation",
      approvedBadge: "Approuvée",
      rejectedBadge: "Refusée",
      pendingHint: "Cette liste de {{count}} personnes dépasse le seuil, elle attend donc l'approbation d'un administrateur. L'envoi se fera automatiquement après approbation.",
      rejectedHint: "Un administrateur a refusé cette campagne ; rien ne sera envoyé. Vous pouvez créer une nouvelle campagne avec un segment plus restreint.",
      rejectedHintWithReason: "Refusée par un administrateur : {{reason}}",
      createdPending: "Votre campagne a été créée — la liste de {{count}} personnes dépasse le seuil, elle attend donc l'approbation d'un administrateur. L'envoi se fera automatiquement après approbation.",
      pageTitle: "Approbations SMS",
      pageDescription: "Les campagnes dépassant le seuil attendent ici — aucun SMS ne part tant qu'elles ne sont pas approuvées.",
      empty: "Aucune campagne en attente d'approbation",
      emptyHint: "Toute campagne dont le nombre de destinataires dépasse le seuil arrive ici automatiquement.",
      thresholdNote: "Seuil actuel : {{count}} destinataires. Modifiable depuis le Centre de contrôle.",
      recipients: "{{count}} destinataire(s)",
      recipientsUnknown: "Nombre de destinataires indéterminé (approbation demandée par précaution)",
      estimatedCost: "Coût estimé",
      segmentsPerMessage: "{{count}} segment(s) par message",
      wedding: "Mariage",
      organizer: "Organisateur",
      createdAt: "Créée le",
      scheduledFor: "Envoi programmé",
      sendNowLabel: "Immédiatement (en attente d'approbation)",
      messagePreview: "Aperçu du message",
      approve: "Approuver",
      reject: "Refuser",
      approving: "Approbation…",
      rejecting: "Refus…",
      rejectReasonLabel: "Motif du refus (facultatif)",
      rejectReasonPlaceholder: "ex. liste trop large, segment à restreindre",
      rejectCancel: "Annuler",
      rejectConfirm: "Refuser",
      approveSuccess: "Campagne approuvée — l'envoi est débloqué.",
      rejectSuccess: "Campagne refusée — rien ne sera envoyé.",
      actionError: "L'action n'a pas pu être effectuée",
      loadMore: "Charger plus",
    },
    round: "Tour {{n}}",
    noSendsYet: "Rien d'envoyé pour l'instant.",
    center: {
      pageTitle: "Centre SMS",
      pageDescription: "Campagnes SMS de tous les mariages : file d'approbation et dépense réelle.",
      tabPending: "En attente d'approbation",
      tabAll: "Toutes les campagnes",
      filterWedding: "Mariage",
      filterWeddingAll: "Tous les mariages",
      filterStatus: "Statut",
      filterStatusAll: "Tous les statuts",
      filterApproval: "Approbation",
      filterApprovalAll: "Tous les états d'approbation",
      filterApprovalNone: "Jamais soumise à approbation",
      filterIncludeDeleted: "Afficher les supprimées",
      filterReset: "Effacer les filtres",
      pageTotals: "{{count}} campagnes sur cette page · {{segments}} segments · ~${{usd}}",
      empty: "Aucune campagne",
      emptyHint: "Aucune campagne SMS n'a encore été créée pour un mariage.",
      emptyFiltered: "Aucune campagne ne correspond aux filtres sélectionnés.",
      deletedBadge: "Supprimée",
      spent: "Dépensé",
      segmentsUsed: "{{count}} segments",
      sends: "Envois",
      deliveredFailed: "{{delivered}} remis · {{failed}} en échec",
      audience: "Audience",
      lastDispatch: "Dernier envoi",
      nextDispatch: "Prochain : {{at}}",
      rejectionReason: "Motif du refus : {{reason}}",
      createdAt: "Créée : {{at}}",
      unitPrice: "unité ${{usd}}",
    },
    status: {
      scheduled: "Planifiée",
      active: "Active",
      dispatching: "Envoi en cours",
      completed: "Terminée",
      canceled: "Annulée",
      failed: "Échec",
    },
    sendStatus: {
      queued: "En attente",
      sent: "Envoyé",
      delivered: "Reçu",
      failed: "Échec",
      undelivered: "Non remis",
    },
    table: {
      guest: "Invité",
      phone: "Téléphone",
      round: "Tour",
      status: "Statut",
    },
  },

  errorBoundary: {
    title: "Un problème est survenu à l’ouverture de cette page",
    desc: "Les autres pages fonctionnent toujours. Rechargez la page ; si cela continue, envoyez-nous le détail.",
    reload: "Recharger la page",
    details: "Détail technique",
  },
  controlCenter: {
    loadPartialFailed: "{{count}} sources de données n’ont pas pu être chargées — l’affichage peut être incomplet.",
    accountsPrivacy: {
      title: "Comptes et confidentialité",
    },
    title: "Centre de contrôle",
    description: "Coupe-circuits, limites financières, dépenses SMS et journaux d'envoi",
    type: "Type",
    killSwitch: "Coupe-circuit",
    group: {
      sms: "SMS",
      other: "Autres",
    },
    smsEnabled: "SMS — Interrupteur principal",
    smsEnabledDesc: "Arrête tout SMS, campagnes + OTP inclus (principal).",
    emailEnabled: "E-mail — Interrupteur principal",
    emailEnabledDesc: "Tout envoi d'e-mail (OTP, alertes, support).",
    smsCampaignsEnabled: "SMS Campagnes",
    smsCampaignsDesc: "SMS d'invitation/rappel ; n'affecte pas la connexion (OTP).",
    masterBadge: "TOUT",
    enabled: "Activé",
    disabled: "Désactivé",
    configSaved: "Configuration enregistrée",
    stats: "Statistiques",
    sms24h: "SMS (24h)",
    email24h: "E-mail (24h)",
    failed24h: "Échoués (24h)",
    blocked24h: "Bloqués (24h)",
    sms7d: "SMS (7j)",
    email7d: "E-mail (7j)",
    logs: "Journal d'envoi",
    recipient: "Destinataire",
    status: "Statut",
    error: "Erreur",
    weddingId: "Mariage",
    createdAt: "Date",
    noLogs: "Aucun enregistrement trouvé.",
    loadMore: "Charger plus",
    filters: {
      all: "Tous",
      sms: "SMS",
      email: "E-mail",
      sent: "Envoyé",
      failed: "Échoué",
      blocked: "Bloqué",
    },
    campaigns: {
      title: "Campagnes SMS",
      active: "Campagnes actives",
      sends24h: "Envois (24h)",
      failed24h: "Échoués (24h)",
      sends7d: "Envois (7j)",
      held: "{{count}} tour(s) en attente",
      pendingApproval: "{{count}} campagne(s) en attente d'approbation",
      reviewLink: "Ouvrir la file d'approbation",
    },
    spend: {
      title: "Dépenses SMS",
      segments: "Segments (aujourd'hui)",
      estCost: "Coût estimé",
      breaker: "Coupe-circuit",
      tripped: "Coupe-circuit déclenché ({{reason}}) — envoi des campagnes arrêté.",
      reset: "Réinitialiser",
      resetDone: "Disjoncteur réinitialisé",
    },
  },

  finance: {
    title: "Limites financières",
    capsTitle: "Plafonds (limites)",
    capsHint: "Modifiez les valeurs — seuls les champs modifiés sont enregistrés. Le serveur valide les bornes finales.",
    save: "Enregistrer",
    override: "Personnalisé",
    default: "Par défaut",
    resetField: "Réinitialiser",
    resetToDefault: "Réinitialiser à la valeur par défaut",
    unitMb: "Mo",
    unitUsd: "USD",
    rangeHint: "Doit être entre {{min}} et {{max}}",
    saveSuccess: "Plafonds financiers mis à jour",
    resetSuccess: "Réinitialisé par défaut",
    boundsError: "Valeur hors de la plage autorisée",
    switchEnabled: "Activé",
    switchDisabled: "Désactivé",
    caps: {
      verifyDailyCap: "Plafond Verify (OTP) quotidien",
      smsSegmentDailyCap: "Plafond quotidien de segments SMS",
      smsPreviewDailyCap: "Plafond quotidien d'aperçus SMS",
      smsRoundRecipientHardCap: "Plafond de destinataires par tour",
      smsManualSegmentMaxGuests: "Segment manuel max. invités",
      emailDailyCap: "Plafond d'e-mails quotidien",
      smsTrPriceUsd: "Prix unitaire SMS (TR)",
      maxImageBytes: "Taille max. photo",
      maxVideoDirectBytes: "Taille max. vidéo (directe)",
      qrScanVisitorDailyCap: "Scans QR quotidiens par visiteur",
      selfRegisterDailyCap: "Inscriptions QR quotidiennes par mariage",
      smsApprovalThreshold: "Seuil d'approbation SMS (destinataires)",
    },
    capsDesc: {
      selfRegisterDailyCap: "Nombre maximal d'inscriptions acceptées via le lien QR/join d'un mariage en 24 heures. Le lien étant public, en cas de fuite ou de bot, la liste d'invités et le budget SMS OTP s'arrêtent ici ; au-delà, les nouvelles inscriptions sont refusées et une alerte part vers le canal admin. Les invités ajoutés manuellement ne comptent pas.",
      smsApprovalThreshold: "Si le nombre de destinataires d'une campagne DÉPASSE cette valeur, la campagne est créée mais aucun SMS ne part tant qu'un administrateur ne l'a pas approuvée. 0 = toute campagne nécessite une approbation (mode verrouillage), 5000 = pratiquement désactivé. Les campagnes sous le seuil partent automatiquement comme avant.",
      qrScanVisitorDailyCap: "Nombre de lignes de scan QR qu'un même appareil peut écrire par jour. L'identité est un hachage de mariage + IP + navigateur (user-agent) + jour — pas seulement l'IP, donc chaque appareil sur le WiFi partagé du lieu a son propre quota. Les scans au-delà du plafond ne sont pas enregistrés (l'invité est quand même redirigé).",
    },
    switchesTitle: "Interrupteurs d'arrêt",
    switchesHint: "Tous ACTIVÉS par défaut. Désactiver les options dangereuses demande une confirmation.",
    switches: {
      verifyEnabled: "Connexion SMS (OTP)",
      uploadsEnabled: "Téléversements média",
      imageTransformEnabled: "Redimensionnement CDN",
      smsApprovalEnabled: "Barrière d'approbation SMS",
      organizerSeesGuestDeletedMedia: "L’organisateur voit les médias retirés par les invités",
    },
    switchesDesc: {
      smsApprovalEnabled: "⚠️ CONTRAIREMENT aux autres : ACTIVÉ = la barrière est en place (les campagnes au-dessus du seuil attendent une approbation). La désactiver supprime totalement l'exigence d'approbation — les campagnes au-dessus du seuil partent directement.",
      verifyEnabled: "Codes de connexion SMS invité/organisateur ; n'affecte pas les campagnes.",
      uploadsEnabled: "Photos/vidéos des invités ; désactiver arrête tous les téléversements.",
      imageTransformEnabled: "Redimensionnement d'image à la volée. Sûr — n'affecte pas les téléversements.",
      organizerSeesGuestDeletedMedia: "Activé : les médias qu’un invité a retirés lui-même apparaissent en lecture seule dans la liste « Supprimés » de l’organisateur (non restaurables). Désactivé (par défaut) : seul l’administrateur de la plateforme les voit.",
    },
    monitoringTitle: "Suivi en direct",
    mon: {
      verify: "Verify (aujourd'hui)",
      segments: "Segments SMS (aujourd'hui)",
      breaker: "Coupe-circuit de dépenses",
      breakerOk: "Normal",
      breakerTripped: "Déclenché",
    },
    confirm: {
      title: "Action dangereuse",
      verifyWarning: "Si Verify est désactivé, invités/organisateurs ne peuvent pas se connecter par SMS.",
      uploadsWarning: "Si les téléversements sont désactivés, les invités ne peuvent pas envoyer de photos.",
      detail: "Vous pouvez réactiver ce paramètre à tout moment.",
      turnOff: "Désactiver",
      approvalWarning: "Si la validation est désactivée, les campagnes SMS au-dessus du seuil partent sans approbation.",
    },
  },

  maintenance: {
    title: "Suivi des erreurs",
    overview: "Vue d'ensemble",
    totalGroups: "Total des groupes d'erreurs",
    unresolved: "Non résolus",
    last24h: "Dernières 24h",
    last7d: "Derniers 7 jours",
    topRoutes: "Routes les plus fréquentes",
    errorGroups: "Groupes d'erreurs",
    events: "Événements",
    markResolved: "Marquer résolu",
    markUnresolved: "Rouvrir",
    resolutionNote: "Note de résolution",
    resolutionSaved: "Enregistré",
    firstSeen: "Première occurrence",
    lastSeen: "Dernière occurrence",
    totalCount: "Total",
    requestId: "ID de requête",
    purge: "Purger les anciens enregistrements",
    purgeConfirm: "Tous les enregistrements de plus de 30 jours seront supprimés. Continuer ?",
    purgeDetail: "Supprime les enregistrements de plus de 30 jours de error_log + error_groups. Une tâche cron s'exécute automatiquement chaque nuit à 03:00.",
    purged: "Anciens enregistrements purgés",
    stackTrace: "Stack Trace",
    noErrors: "Aucune erreur trouvée.",
    groupNotFound: "Groupe d'erreurs introuvable.",
    description: "Groupes d'erreurs et surveillance de la santé système",
    statusResolved: "Résolu",
    statusOpen: "Ouvert",
    colLastSeen: "Vu dernièrement",
    colKind: "Type",
    colMethod: "Méthode",
    colPath: "Route",
    colError: "Erreur",
    colCount: "Nombre",
    message: "Message",
    dateLabel: "Date",
    weddingLabel: "Mariage",
    actorLabel: "Acteur",
    timeJustNow: "à l'instant",
    timeMinutes: "{{count}}min",
    timeHours: "{{count}}h",
    timeDays: "{{count}}j",
    kind: {
      exception: "Exception",
      soft: "Erreur douce",
    },
    filters: {
      all: "Tous",
      unresolvedOnly: "Ouverts uniquement",
      pathSearch: "Rechercher une route… (Entrée)",
    },
  },
  // ─── Home Feed (Guest) ─────────────────────────────
  home: {
    rsvpNudge: "Serez-vous présent au mariage ?",
    rsvpNudgeAction: "Répondre",
    rsvpNudgeTitle: "On vous attend !",
    rsvpNudgeText: "Répondez à l'invitation pour nous aider à planifier.",
    rsvpNudgeRespond: "Répondre maintenant",
    newActivity: "{{count}} nouveaux moments partagés",
    topLiked: "Les plus aimées",
    recentActivity: "Activité récente",
    seeAll: "Tout voir",
    viewGallery: "Voir la galerie",
    welcomeBack: "Bon retour, {{name}}",
    rsvpStatus: "Votre statut RSVP",
    rsvpNotResponded: "Vous n'avez pas encore répondu",
    partyOf: "{{count}} personne(s)",
    weddingDetails: "Détails du mariage",
    dateTime: "Date et heure",
    venue: "Lieu",
    updateRsvp: "Mettre à jour",
    respondNow: "Répondre maintenant",
    noMediaYet: "Aucune photo partagée",
    noMediaYetHint: "Soyez le premier à télécharger une photo !",
    noActivityYet: "Aucune activité pour l'instant",
    empty: "Aucune activité pour l'instant. Soyez le premier à télécharger une photo !",
    countdown: {
      daysLeft: "jours avant le mariage",
      daysAgo: "jours depuis le mariage",
      dayUnit: "J",
      hoursUnit: "H",
      minsUnit: "Min",
      secsUnit: "Sec",
      label: "Le Grand Jour Approche",
      labelFor: "{{event}} — Compte à rebours",
      todayFor: "Aujourd'hui, c'est {{event}} !",
      today: "Aujourd'hui c'est le mariage !",
    },
  },

  themes: {
    title: "Thèmes",
    description: "Arrière-plans par défaut utilisés sur toute la plateforme. Les organisateurs peuvent les personnaliser par mariage.",
    backgrounds: "Arrière-plans",
    slotGuestAuth: "Connexion invité",
    slotOrganizerAuth: "Connexion organisateur",
    slotGuestCountdown: "Compte à rebours",
    slotGuestRsvp: "RSVP",
    slotGuestAuthDesc: "Arrière-plan affiché sur l'écran de connexion de l'app invité",
    slotOrganizerAuthDesc: "Arrière-plan affiché sur l'écran de connexion du panneau organisateur",
    slotGuestCountdownDesc: "Arrière-plan affiché sur la page de compte à rebours avant le mariage",
    slotGuestRsvpDesc: "Arrière-plan affiché sur la page RSVP des invités",
    upload: "Télécharger",
    change: "Changer",
    deleteSlot: "Supprimer",
    uploaded: "Téléchargé",
    deleted: "Supprimé",
    uploadFailed: "Échec du téléchargement",
    deleteFailed: "Échec de la suppression",
    noBackground: "Pas d'arrière-plan",
    dragDrop: "Cliquez ou faites glisser pour télécharger une image",
    fileHint: "Max 10 Mo · JPEG, PNG, WebP, AVIF · Recommandé 1920×1080",
    active: "Actif",
    confirmDelete: "Êtes-vous sûr de vouloir supprimer cet arrière-plan ?",
    // ─── Join Themes (Organizer) ──────────────────────
    presets: "Thèmes prédéfinis",
    customize: "Personnaliser",
    palette: "Palette de couleurs",
    fontPair: "Paire de polices",
    images: "Images",
    heroImage: "Image principale",
    heroImageHint: "Arrière-plan de la page d'invitation",
    gallery: "Galerie",
    galleryHint: "Max 5 photos",
    preview: "Aperçu",
    publish: "Publier",
    customized: "Personnalisé",
    reset: "Réinitialiser",
    saveSuccess: "Thème enregistré",
    saveError: "Échec de l'enregistrement",
    uploadError: "Échec du téléchargement",
    deleteError: "Échec de la suppression",
    fontPairHeadingPreview: "Titre du mariage",
    fontPairBodyPreview: "Aperçu du texte d'invitation",
    heroImageDesc: "L'image de fond plein écran que les invités voient à l'ouverture du lien. Utilise le dégradé du thème si non définie.",
    galleryDesc: "Photos affichées dans la section galerie. Laissez vide pour masquer la galerie.",
    joinTitle: "Thème de la page d'invitation",
    joinSubtitle: "Personnalisez l'apparence de la page que voient vos invités.",
    previewCoupleName: "Emma & Julien",
    previewDateLocation: "12 septembre 2026 · Paris",
    previewJoinTitle: "Rejoignez-nous",
    previewJoinSubtitle: "Votre nom et numéro de téléphone suffisent pour accepter l'invitation.",
    previewRegisterBtn: "S'inscrire",
    uploadTooLarge: "Fichier trop volumineux. Maximum 10 Mo par photo.",
    uploadInvalidType: "Seuls les formats JPEG, PNG, WebP ou AVIF sont acceptés.",
    videoSection: "Animation de défilement",
    videoDesc: "En faisant défiler la page, la vidéo avance image par image. Téléchargez un fichier MP4 ou WebM.",
    videoUpload: "Télécharger une vidéo",
    videoExtracting: "Extraction des images...",
    videoUploading: "Téléchargement...",
    videoProgress: "{{done}} / {{total}} images",
    videoFrameCount: "{{count}} images prêtes",
    videoRemove: "Supprimer l'animation",
    videoSuccess: "Animation prête",
    videoError: "Erreur lors du traitement",
    videoInvalidType: "Seuls les formats MP4 ou WebM sont acceptés.",
    videoTooLarge: "Vidéo trop volumineuse. Maximum 200 Mo.",
    deleteImageConfirm: "Êtes-vous sûr de vouloir supprimer cette image ?",
    deleteVideoConfirm: "Êtes-vous sûr de vouloir supprimer l'animation ? Toutes les images seront supprimées.",
    mobile: "Mobile",
    desktop: "Bureau",
    noHero: "Pas d'image",
    addImage: "Ajouter une image",
    changeImage: "Modifier",
    layoutPickerTitle: "Thème de mise en page",
    layoutPickerSubtitle: "Choisissez la mise en page classique ou l'un des thèmes premium. Les thèmes modifiables permettent de personnaliser entièrement les textes et les images.",
    layoutEditorTitle: "Paramètres du thème",
    layoutEditorSubtitle: "Personnalisez textes, images et couleurs.",
    // ─── Layout picker groupe/statut + noms de thème ───
    layoutGroupClassic: "Classique",
    layoutGroupPremium: "Premium",
    layoutStatusEditable: "Modifiable",
    layoutStatusClassic: "Thème classique",
    layoutStatusPreview: "Aperçu",
    layoutNames: {
      default: "Classique (par défaut)",
      cinematic: "Cinématique",
      minimal: "Minimal",
      parallax: "Parallaxe romantique",
      editorial: "Éditorial audacieux",
      "dark-romance": "Romance sombre",
    },
  },

  // ─── Landing (site vitrine, `/`) ───────────────────
  // ─── Baskı (ortak paket @wedding/print-kit) ─────────
  printKit: {
    title: "Impression",
    description: "Cartes QR à votre mariage — avec les prénoms, la date et votre propre QR code. « Imprimer / PDF » donne un PDF à taille réelle pour l’imprimeur.",
    nameA: "Premier prénom",
    nameB: "Second prénom",
    date: "Date",
    tables: "Numéros de table",
    tablesHint: "Ex. 1-20, VIP — une page par table ({{max}} max).",
    tableCard: "Carte de table",
    tableCardSize: "A6 · 105 × 148 mm",
    welcomeSign: "Panneau d’accueil",
    welcomeSignSize: "50 × 70 cm",
    handCard: "Carte à main",
    handCardSize: "85 × 55 mm",
    pages: "{{count}} pages",
    print: "Imprimer / PDF",
    printing: "Fenêtre d’impression ouverte — choisissez « Enregistrer au format PDF ».",
    printFailed: "Impossible d’ouvrir la fenêtre d’impression.",
    qrTarget: "Le QR ouvre :",
    langNote: "textes dans la langue du mariage ({{lang}})",
    tip: "Astuce : scannez le QR d’une impression test avant l’imprimeur. Gardez « Graphiques d’arrière-plan » activé.",
    tpl: {
      shareEyebrow: "Partagez vos souvenirs avec nous",
      step1: "Scannez",
      step2: "Partagez",
      step3: "Regardez à l’écran",
      table: "Table",
      welcome: "Bienvenue",
      headlineA: "Chaque instant de ce soir",
      headlineB: "est entre vos mains.",
      captionStrong: "Scannez avec votre appareil photo,",
      caption: "partagez photos et vidéos — elles s’affichent sur le grand écran en quelques secondes.",
      noApp: "Aucune application requise",
      handEyebrow: "Ce soir",
      handLine1: "un des instants",
      handLine2: "vient de vous.",
      handSteps: "Scannez · Partagez · Regardez",
    },
  },

  // ─── Canlı demo girişi (web, F7) ─────────
  demoEnter: {
    title: "Bienvenue dans la démo en direct",
    body: "Visitez comme un invité : importez des photos, laissez des cœurs, ouvrez Sahne. Aucun numéro de téléphone requis.",
    nameLabel: "Votre prénom (facultatif)",
    namePlaceholder: "Ex. Deniz",
    submit: "Rejoindre la démo",
    entering: "Connexion…",
    note: "Vos photos passent en modération, ne sont jamais publiques et sont supprimées chaque nuit.",
    failed: "Impossible de rejoindre la démo pour le moment — réessayez bientôt.",
    capReached: "La démo est très fréquentée aujourd’hui — réessayez demain.",
  },

  // ─── Albümü indir (ortak paket @wedding/album-export) ─────────
  albumExport: {
    button: "Télécharger l’album",
    meta: "{{count}} éléments · {{size}}",
    empty: "Aucune photo approuvée pour l’instant.",
    onlyApproved: "Photos approuvées uniquement, qualité d’origine (ZIP)",
    partsHint: "L’album est volumineux : il est divisé en {{parts}} parties à télécharger séparément.",
    part: "Partie {{n}} ({{from}}–{{to}})",
    started: "Téléchargement lancé — cela peut prendre quelques minutes pour un grand album.",
    failed: "Impossible de charger les infos de l’album.",
  },

  // ─── Admin: Satış & Site (landing içeriği) ─────────
  siteAdmin: {
    title: "Ventes & Site",
    description: "Gérez les prix et contenus affichés sur le site vitrine (wedding.mertbal.com). Les modifications enregistrées apparaissent sur le site sous 1 à 2 minutes.",
    openSite: "Ouvrir le site",
    reload: "Actualiser",
    tabs: {
      pricing: "Prix",
      leads: "Demandes de devis",
      proof: "Preuve sociale",
      media: "Vitrine",
      retention: "Conservation",
      demo: "Démo invité",
      sales: "Vente en ligne",
      legal: "Mentions légales",
      ledger: "Registre",
    },
    save: "Enregistrer",
    saving: "Enregistrement…",
    saved: "Enregistré — en ligne sous 1 à 2 minutes.",
    saveFailed: "Échec de l’enregistrement : {{error}}",
    invalid: "Certains champs sont invalides — corrigez les lignes signalées.",
    loadFailed: "Impossible de charger les réglages.",
    retry: "Réessayer",
    unsaved: "Modifications non enregistrées",
    pricing: {
      showTitle: "Afficher les prix sur le site",
      showDesc: "Désactivé, les cartes des formules n’affichent pas de prix, l’achat en ligne se ferme et le formulaire n’affiche pas d’estimation ; le visiteur demande un devis.",
      packagesTitle: "Prix des formules",
      packagesHint: "Le prix et les nombres (invités/médias/stockage) viennent de la définition de la formule — carte du site, achat, formulaire de devis et vente manuelle utilisent les mêmes nombres. Plus de prix par tranche d’invités.",
      editPackages: "Modifier dans Formules",
      packageGuests: "jusqu’à {{n}} invités",
      noteTitle: "Note sur les prix",
      noteHint: "Affiché sous les cartes des formules. Vide, le texte par défaut s’affiche en 4 langues ; la note saisie ici n’est pas traduite.",
    },
    leads: {
      unavailableTitle: "L’enregistrement des demandes n’est pas encore actif",
      unavailableBody: "Une fois la mise à jour de la base (migration 052) appliquée, les demandes du formulaire apparaissent ici. D’ici là, elles arrivent uniquement par e-mail.",
      funnelTitle: "Formulaire de devis — 30 derniers jours",
      funnelHint: "Compteurs quotidiens anonymes ; chaque étape compte une fois par chargement de page. Pourcentages rapportés aux visiteurs ayant vu le formulaire.",
      stepView: "A vu le formulaire",
      stepStep1: "A commencé",
      stepStep2: "A atteint l’étape contact",
      stepSubmit: "A envoyé",
      pct: "{{pct}} %",
      filterAll: "Toutes",
      planChosen: "Formule {{plan}}",
      planCustom: "Plus grand · devis sur mesure",
      statusLabel: "Statut",
      status: {
        new: "Nouvelle",
        contacted: "Contactée",
        won: "Gagnée",
        lost: "Perdue",
      },
      empty: "Aucune demande pour ce filtre.",
      emailNotSent: "E-mail non envoyé",
      noEstimate: "Pas d’estimation",
      note: "Note",
      notePh: "Notes d’appel (admins uniquement)",
      saveNote: "Enregistrer la note",
      delete: "Supprimer",
      deleteConfirm: "Supprimer définitivement la demande de {{name}} ? (demande d’effacement)",
      deleted: "Demande supprimée.",
      updated: "Mis à jour.",
      failed: "Échec de l’action : {{error}}",
      loadMore: "Charger plus",
      loadFailed: "Impossible de charger les demandes.",
    },
    proof: {
      statsTitle: "Chiffres d’utilisation réels",
      statsDesc: "Affichés sur le site sous la forme « X albums de mariage · Y photos et vidéos partagées ». Les chiffres viennent de la base ; un chiffre sous son seuil n’est jamais affiché.",
      show: "Afficher les chiffres sur le site",
      minWeddings: "Seuil d’affichage — mariages",
      minMedia: "Seuil d’affichage — photos",
      current: "Actuellement",
      currentWeddings: "{{n}} mariages (avec au moins {{min}} photos approuvées)",
      currentMedia: "{{n}} photos approuvées",
      visible: "affiché sur le site",
      hidden: "sous le seuil, masqué",
      off: "désactivé",
      unknown: "Impossible de lire les chiffres pour le moment.",
      testimonialsTitle: "Témoignages de couples",
      testimonialsDesc: "N’ajoutez que de vrais témoignages dont vous avez l’autorisation de publication — un faux avis est une publicité illicite. Le texte s’affiche dans la langue saisie.",
      empty: "Aucun témoignage — la section est masquée sur le site.",
      add: "Ajouter un témoignage",
      couple: "Couple",
      couplePh: "Ayşe & Can",
      when: "Quand",
      whenPh: "Juin 2026",
      city: "Ville",
      cityPh: "Izmir",
      quote: "Témoignage",
      quotePh: "Chaque photo prise par nos invités était dans l’album le lendemain matin…",
      rating: "Note",
      noRating: "Sans note",
      showOnSite: "Afficher sur le site",
      moveUp: "Monter",
      moveDown: "Descendre",
      remove: "Retirer",
      limit: "{{max}} témoignages maximum.",
    },
    media: {
      consent: "N’importez que des photos et vidéos dont le couple autorise la publication ; un contenu montrant le visage d’invités exige leur accord.",
      photosTitle: "Vraies photos de mariage",
      photosHint: "Une fois importées, elles remplacent les images d’illustration du site, utilisées dans cet ordre partout. Paysage, au moins 1600 px ; JPEG/PNG/WebP/AVIF, 10 Mo max.",
      photosEmpty: "Aucune photo — le site affiche des images d’illustration.",
      addPhotos: "Ajouter des photos",
      videoTitle: "Vidéo Sahne",
      videoHint: "Affichée sous la section Sahne, intitulée « Lors d’un vrai mariage ». MP4 (H.264) uniquement, 95 Mo max ; 30 à 60 s conseillées. Une image de couverture évite de télécharger la vidéo au chargement.",
      video: "Vidéo",
      videoEmpty: "Aucune vidéo — le bloc est masqué.",
      poster: "Image de couverture",
      posterEmpty: "Pas de couverture — le navigateur affiche la première image.",
      upload: "Importer",
      replace: "Remplacer",
      uploadingN: "Import {{n}}/{{total}}",
      processing: "Envoyé, enregistrement sur le serveur…",
      uploaded: "{{count}} fichier(s) importé(s).",
      removeConfirm: "Supprimer définitivement ce fichier du site et du stockage ?",
      removed: "Supprimé.",
      err: {
        too_large: "Fichier trop volumineux (images 10 Mo, vidéo 95 Mo).",
        mp4_only: "La vidéo doit être au format MP4.",
        image_only: "Le fichier n’est pas une image JPEG/PNG/WebP/AVIF valide.",
        limit: "12 photos maximum.",
        network: "Erreur réseau — réessayez.",
        media_changed: "La vitrine a changé dans un autre onglet — la liste a été rechargée, réessayez.",
        length_required: "Taille du fichier illisible — réessayez.",
      },
    },
    retention: {
      title: "Promesse de conservation de l’album",
      desc: "Affichée dans la FAQ du site et la note des offres. Le système ne supprime jamais automatiquement les photos approuvées ; c’est la durée minimale promise.",
      show: "Afficher la promesse sur le site",
      months: "Durée minimale (mois)",
      hidden: "Promesse masquée — la question n’apparaît pas dans la FAQ.",
      warn: "Réduire la durée ne modifie pas ce qui a été promis aux clients ayant acheté sous cette promesse.",
    },
    demo: {
      title: "Démo invité (mariage exemple)",
      desc: "Les visiteurs entrent sur /sample-wedding sans numéro et essaient l’application invité (envoi, galerie, Sahne). Ce n’est pas un exemple d’invitation. Leurs envois passent en modération, ne sont jamais publics et sont supprimés chaque nuit.",
      state: "État",
      live: "En ligne",
      none: "Non installée",
      seedMedia: "Photos d’amorce",
      visitors: "Visiteurs du jour",
      pending: "En attente",
      setup: "Installer la démo",
      reset: "Réinitialiser",
      resetConfirm: "Tout supprimer dans le mariage de démo et le réinstaller ? (visiteurs, imports, commentaires)",
      setupDone: "Démo prête — {{count}} photos d’amorce.",
      clearVisitors: "Vider les visiteurs",
      clearConfirm: "Supprimer les visiteurs du jour et leurs imports ? Les photos d’amorce restent.",
      cleared: "{{count}} visiteur(s) supprimé(s).",
      open: "Ouvrir la démo invité",
      moderation: "Aller à la modération",
      seedHint: "Les photos d’amorce sont copiées depuis la Vitrine ; si elle est vide, des images d’illustration sont utilisées. Le nettoyage nocturne ne tourne qu’en production.",
      slugTaken: "« {{slug}} » appartient à un vrai mariage — la démo ne peut pas être installée, rien n’a été supprimé.",
      ctaTitle: "Afficher sur le site vitrine",
      ctaDesc: "Une fois publiée, un petit lien « Essayer comme un invité » apparaît à l’étape « Partager » de « Comment ça marche » ; les boutons principaux ne changent pas. Impossible de publier avant d’installer la démo.",
      onSite: "Publiée sur le site",
      offSite: "Non publiée",
      publish: "Publier sur le site",
      unpublish: "Retirer du site",
      published: "Démo invité publiée sur le site.",
      unpublished: "Démo invité retirée du site.",
    },
    sales: {
      selfServeTitle: "Les organisateurs peuvent ouvrir leur compte",
      selfServeOn: "Activé : l’espace organisateur affiche une page « Créer un compte » (/signup) — nom + accord des conditions ; un compte Free s’ouvre une fois le code e-mail vérifié. L’écran de connexion ne crée jamais de compte.",
      selfServeOff: "Désactivé (recommandé) : seuls les organisateurs existants se connectent ; vous ouvrez les nouveaux comptes. Un e-mail inconnu saisi à la connexion ne crée aucun compte ; l’adresse reçoit une invitation à demander un devis.",
      closeConfirm: "Fermer les inscriptions d’organisateurs ? Les comptes existants ne sont pas affectés.",
      ordersTitle: "Vente en ligne (Acheter)",
      ordersLive: "Active et en ligne : « Acheter » apparaît sur les formules payantes ; les commandes arrivent ci-dessous.",
      ordersBlocked: "Active mais PAS en ligne — elle apparaîtra une fois les points ci-dessous réglés.",
      ordersOff: "Désactivée : les visiteurs ne voient que le formulaire de devis.",
      ordersOpenConfirm: "Activer la vente en ligne ? « Acheter » apparaîtra sur le site ; paiement par virement, vous confirmez les commandes ici. Une relecture juridique des contrats est recommandée.",
      ledgerRequired: "La vente en ligne ne peut pas être ouverte avant l’application du registre (migration 057) — les preuves de contrat et de prix doivent être conservées.",
      needLegal: "Identité du vendeur (nom, adresse, e-mail) incomplète :",
      needPricing: "Les prix sont masqués sur le site :",
      ordersHint: "Pas encore de passerelle de paiement (iyzico/PayTR) : répondez à la commande avec les coordonnées de paiement puis marquez « Payée » à réception — le compte s’ouvre et l’acheteur reçoit identifiants + contrats.",
      selfServeMoved: "L’ouverture de compte par l’organisateur est un réglage de la plateforme ; il se trouve désormais dans :",
    },
    orders: {
      title: "Commandes",
      desc: "Achats en ligne. Jamais supprimées — conservées 10 ans comme pièces de facturation.",
      filter: {
        pending: "En attente",
        paid: "Payée",
        cancelled: "Annulée",
        all: "Toutes",
      },
      unavailable: "La table des commandes n’existe pas encore — elles apparaîtront ici après la migration 053 (d’ici là, l’achat renvoie 503).",
      empty: "Aucune commande avec ce statut.",
      more: "Afficher plus",
      loadFailed: "Impossible de charger les commandes : {{error}}",
      buyer: "Acheteur",
      eventDate: "Événement",
      address: "Facturation",
      email: "E-mail",
      phone: "Tél.",
      created: "Commande : {{at}}",
      paidAt: "Paiement : {{at}}",
      paymentNote: "Note de paiement",
      paymentNotePh: "Note de paiement (ex. virement 13.10, n° de reçu)",
      adminNote: "Note interne",
      adminNotePh: "Note interne (invisible pour l’acheteur)",
      markPaid: "Marquer payée",
      cancel: "Annuler",
      saveNotes: "Enregistrer les notes",
      cancelConfirm: "Annuler {{number}} ?",
      paidCreated: "Payée — compte organisateur ouvert.",
      paidNoEmail: "Payée, mais l’e-mail à l’acheteur n’a pas pu partir — réessayez avec « Envoyer l’e-mail ».",
      deactivated: "Ce compte organisateur est désactivé — réactivez-le dans Utilisateurs.",
      cancelled: "Commande annulée.",
      cancelPaidConfirm: "Annuler {{number}} (remboursement) ? La formule est retirée du mariage : sans autre formule, le mariage est suspendu (plus de nouveaux invités ni d’envois). Invités et photos ne sont pas supprimés.",
      paidExisting: "Payée — rattachée au compte existant (formule du compte inchangée).",
      paidEmailSkipped: "Aucun e-mail envoyé à l’acheteur (votre choix) — transmettez la copie du contrat autrement.",
      emailInfoTitle: "E-mails d’achat",
      emailInfo1: "Aucun e-mail à l’acheteur lors de la commande ; la boîte de l’entreprise est notifiée — répondez-y avec les infos de paiement.",
      emailInfo2: "Une fois « Payée » (facultatif), l’acheteur reçoit le lien d’accès, le mariage concerné et une copie de l’information précontractuelle + du contrat de vente à distance. Envoi possible plus tard via « Envoyer l’e-mail ».",
      emailInfo3: "Pas d’e-mail à l’annulation ; vous gérez l’échange de remboursement.",
      paidTitle: "Marquer comme payée",
      applyTo: "Mariage auquel appliquer la formule",
      applyNext: "Laisser l’organisateur choisir (la formule attend dans son compte)",
      applyHint: "La formule vaut pour un seul événement ; la formule du compte ne change pas. Les limites du mariage choisi passent au droit de cette commande.",
      sendEmail: "Envoyer l’e-mail d’accès + contrat à l’acheteur",
      noEmailWarn: "Une copie du contrat de vente à distance doit être remise à l’acheteur sur support durable — sinon, transmettez-la autrement.",
      confirmPaid: "Confirmer",
      close: "Annuler",
      weddingsFailed: "Impossible de charger les mariages : {{error}}",
      entitlement: "Droit : {{guests}} invités · {{media}} médias · {{storage}}",
      appliedTo: "Mariage : {{title}}",
      appliedNext: "Mariage : en attente du choix de l’organisateur (formule dans son compte)",
      move: "Déplacer",
      apply: "Appliquer",
      moved: "Formule appliquée au mariage.",
      emailSentAt: "E-mail envoyé ({{at}})",
      emailNotSent: "E-mail non envoyé",
      sendEmailNow: "Envoyer l’e-mail",
      resendEmail: "Renvoyer",
      emailSent: "E-mail envoyé à l’acheteur.",
      conflict: "Cette commande a été traitée dans un autre onglet — liste actualisée.",
      migrationRequired: "« Payée » nécessite la migration 055 (colonnes de droit absentes).",
      weddingNotOwned: "Le mariage choisi n’appartient pas à cet acheteur.",
      manualNew: "Commande manuelle",
      manualHint: "Vente sur devis/virement. Le forfait du compte NE change PAS — la commande devient un droit pour un seul mariage (une fois marquée « Payée »). Les commandes en attente non payées sous 7 jours sont annulées automatiquement.",
      legacyBadge: "Transition (ancien forfait de compte)",
      manualPlan: "Formule",
      manualAmount: "Montant (₺)",
      manualAmountEach: "Montant — par pack (₺)",
      manualQuantity: "Quantité (packs)",
      manualQuantityHint: "{{count}} commandes distinctes seront ouvertes — chacune donne droit à un mariage, avec son propre numéro. L'organisateur attribue chaque pack à un mariage.",
      pickOrganizer: "Organisateur existant (facultatif)",
      pickOrganizerPh: "Rechercher par e-mail ou nom",
      pickNone: "Aucun organisateur trouvé — saisissez l'acheteur manuellement.",
      pickFailed: "La recherche a échoué, réessayez.",
      pickedLabel: "Organisateur : {{name}} · {{email}}",
      pickChange: "Changer",
      pickWeddings: "{{count}} mariages",
      pickHint: "La sélection remplit le nom, l'e-mail et le téléphone du compte ; une fois payée, la formule apparaît dans Mes formules de ce compte.",
      manualCreate: "Créer la commande",
      manualCreated: "{{number}} créée — marquez-la « Payée » à réception du paiement.",
      manualCreatedMany: "{{count}} commandes ouvertes : {{numbers}} — marquez chacune « Payée » à réception du paiement.",
      fix: "Corriger",
      saveFix: "Enregistrer la correction",
      corrected: "Coordonnées de l’acheteur corrigées.",
      foreignLabel: "Mariage sur un autre compte (adresse)",
      foreignPh: "exemple-mariage",
      foreignHint: "Si le mariage a été créé avec une autre adresse e-mail, saisissez son adresse (slug) ; le droit va à ce mariage et le compte de l’acheteur ne change pas.",
      guestsShort: "{{n}} invités",
      archived: "archivé",
      overCap: "Ce mariage compte déjà {{guests}} invités ; la commande en autorise {{cap}}. Le surplus n’est pas supprimé, mais les nouvelles inscriptions QR se ferment.",
      impact: "Impact — {{wedding}} : actuellement {{guests}} invités / {{media}} médias. Limite après annulation : {{guestsAfter}} invités / {{mediaAfter}} médias.",
      impactOver: "⚠️ Après annulation, le mariage reste AU-DESSUS de sa limite : nouveaux invités et envois bloqués.",
      weddingNotFound: "Aucun mariage à cette adresse.",
      notPending: "Les coordonnées de l’acheteur ne se corrigent que sur une commande en attente (et séparément d’un changement de statut).",
      contractCopy: "Copie du contrat",
      noContract: "Aucun texte de contrat enregistré pour cette commande (vente sur devis ou commande antérieure au registre).",
      ledgerEvents: "{{count}} entrées au registre.",
      listPrice: "(prix catalogue {{price}})",
      refundReasonPrompt: "Motif du remboursement (obligatoire, inscrit au registre) :",
      moveReason: "Motif du transfert (obligatoire)",
      moveReasonPh: "ex. lié au mauvais mariage",
      paymentRef: "Référence de paiement (obligatoire)",
      paymentRefHint: "N° de reçu / libellé du virement — preuve d’encaissement, inscrite au registre.",
      packageOption: "{{label}} · {{guests}} invités · {{price}}",
      noPackages: "Aucune formule vendable — définissez-en une dans Formules.",
      noListPrice: "Cette formule n’a pas de prix catalogue (sur devis) — un motif est obligatoire.",
      listPriceNote: "Prix catalogue {{price}} — montant et nombres viennent de la définition de la formule.",
      discountNote: "Prix catalogue {{price}} · remise {{discount}} — un motif est obligatoire.",
      reasonRequired: "Motif (obligatoire — remise / devis)",
      errors: {
        paymentRef: "Une référence de paiement (reçu / libellé de virement) est requise pour marquer comme payé.",
        reason: "Un motif est requis (au moins 3 caractères).",
        packageInUse: "Cette formule a été utilisée (invités/médias présents ou événement passé) — elle ne peut pas être libérée ; remboursez ou transférez-la.",
        targetHasPackage: "Le mariage choisi a déjà une formule payée — une formule par mariage.",
        packageNotFound: "Définition de formule introuvable ou inactive.",
        packageNotSellable: "La formule par défaut (Free) ne se vend pas.",
        invalidTransition: "Action impossible dans l’état actuel de la commande.",
      },
    },
    ledger: {
      title: "Registre des ventes",
      desc: "Historique des prix et conditions, des limites de formule, des commandes et des packs supplémentaires. Ajout seul : rien ne peut être modifié ni supprimé, conservé au moins 10 ans. Permet de montrer quel prix s’appliquait à quelle date et le texte exact du contrat accepté par l’acheteur.",
      verify: "Vérifier l’intégrité",
      verifyOk: "Registre intact — {{count}} entrées vérifiées de bout en bout.",
      verifyBroken: "Attention : l’entrée n° {{seq}} a été modifiée ou la chaîne est rompue. Comparez avec une sauvegarde.",
      unavailable: "Le registre n’existe pas encore — il commence à enregistrer une fois la migration 057 appliquée (la vente en ligne ne peut pas être ouverte avant).",
      empty: "Aucune entrée pour ce filtre.",
      loadFailed: "Impossible de lire le registre : {{error}}",
      more: "Voir plus",
      actor: "Par",
      contract: "Texte accepté par l’acheteur (empreinte SHA-256 : {{hash}})",
      filter: {
        all: "Tout",
        settings: "Prix et conditions",
        plan: "Limites des formules",
        order: "Commandes",
        addon: "Packs supplémentaires",
      },
      accountPlanSubject: "Compte {{id}} : {{before}} → {{after}}",
      packageSubject: "{{kind}} {{label}} · {{id}}",
      packageFree: "Formule Free",
      packageLegacy: "Formule de transition",
      events: {
        created: "créée",
        paid: "payée",
        cancelled: "annulée",
        moved: "déplacée",
        corrected: "corrigée",
        applied: "attribuée au mariage",
        updated: "modifiée",
        deleted: "supprimée",
        baseline: "valeur avant le registre",
        accountPlan: "Forfait de compte attribué",
        granted: "formule attribuée",
        assigned: "attribuée au mariage",
        replaced: "remplacée par une formule payante",
        revoked: "retirée",
        noted: "note modifiée",
        propagated: "définition appliquée aux formules vendues",
      },
    },
    addons: {
      save: "Enregistrer les packs",
      title: "Packs d’invités supplémentaires (inscriptions QR)",
      desc: "Quand le quota d’invités est atteint, l’organisateur ouvre un pack pour les personnes supplémentaires inscrites par QR. Le pack est actif IMMÉDIATEMENT et apparaît « paiement en attente » ; encaissez-le dans Vente en ligne → Packs supplémentaires. Les prix sont toujours lus ici (serveur).",
      enabled: "Les organisateurs peuvent ouvrir des packs",
      seats: "Invités",
      price: "Prix (₺)",
      seatsFor: "Nombre d’invités du pack {{n}}",
      priceFor: "Prix du pack {{n}}",
      perGuest: "≈ {{price}} par invité",
      invalid: "Invités 1–1000 et prix 0–100 000 en nombres entiers ; pas de nombre d’invités en double.",
      panelTitle: "Packs supplémentaires",
      panelDesc: "Packs d’inscription QR ouverts par les organisateurs. Actifs dès l’ouverture ; « Payé » à réception du virement, « Annuler » si impayé (les places ferment aussitôt).",
      filter: { pending: "Paiement en attente", paid: "Payé", cancelled: "Annulé", all: "Tous" },
      markPaid: "Payé",
      cancel: "Annuler",
      paidConfirm: "Marquer le pack +{{seats}} de /{{slug}} comme payé ?",
      paidRefPrompt: "Marquer le pack +{{seats}} de /{{slug}} ({{amount}}) comme payé ? Référence de paiement (n° de reçu / libellé du virement, obligatoire) :",
      paymentRefRequired: "Une référence de paiement (reçu / libellé du virement) est requise.",
      cancelConfirm: "Annuler le pack +{{seats}} de /{{slug}} ? Les places ferment aussitôt ; les invités inscrits restent.",
      markedPaid: "Pack marqué comme payé.",
      cancelled: "Pack annulé.",
      empty: "Aucun pack dans cet état.",
      unavailable: "La table des packs n’existe pas encore — elle apparaîtra après la migration 056.",
      loadFailed: "Impossible de charger les packs : {{error}}",
    },
    legal: {
      title: "Identité légale",
      desc: "Le responsable du traitement (avis KVKK) et le prestataire (conditions d’utilisation) proviennent de ces champs. Nom/raison sociale, adresse et e-mail sont requis avant d’ouvrir la vente payante (commandes).",
      publicWarn: "Chaque champ rempli est publié PUBLIQUEMENT sur /privacy et /terms. Laissez vide un champ à ne pas publier — un champ vide n’apparaît pas.",
      complete: "Identité complète — les pages de contrat et de vente peuvent être ouvertes.",
      incomplete: "Incomplet : tant que nom/raison sociale, adresse et e-mail manquent, les pages n’affichent que l’e-mail de contact et la vente payante reste fermée.",
      name: "Nom complet / raison sociale",
      titleField: "Titre / profession (facultatif)",
      address: "Adresse",
      phone: "Téléphone",
      email: "E-mail (contact@mertbal.com si vide)",
      taxOffice: "Centre des impôts",
      taxId: "N° fiscal / d’identité",
      mersis: "N° MERSIS",
      kep: "E-mail recommandé (KEP)",
      openKvkk: "Ouvrir la page confidentialité",
      openTerms: "Ouvrir la page conditions",
      clearConfirm: "Vider et enregistrer tous les champs d’identité légale ? Les pages n’afficheront que l’e-mail de contact.",
      clear: "Tout vider",
    },
  },

  plansAdmin: {
    siteNote: "La définition de la formule est la SOURCE UNIQUE : la carte du site, l’achat en ligne, la vente manuelle et « Attribuer une formule » prennent ici les nombres (invités/médias/stockage/SMS) et le PRIX. Le site ne montre que Free · Pro · Max ; les noms sont fixes. Les autres formules sont privées (entreprise) : invisibles sur le site, vendues sur devis / « Attribuer ». Une formule vendue est un contrat : modifier la définition n’affecte que les NOUVELLES ventes ; les formules vendues gardent les nombres achetés.",
    onSite: "Sur le site",
    onSiteHint: "Affichée sur le site vitrine — non supprimable, limites modifiables",
    private: "Privée",
    privateHint: "Formule privée — invisible sur le site vitrine",
    reactivate: "Réactiver",
    created: "Formule créée.",
    updated: "Formule mise à jour.",
    deleted: "Formule désactivée.",
    reactivated: "Formule réactivée.",
    failed: "Échec de l’action : {{error}}",
    sitePlanLocked: "Cette formule est sur le site vitrine — suppression impossible.",
    subtitle: "Définitions des formules : nombres et prix",
    price: "Prix (₺)",
    priceHint: "Laissez vide pour vendre uniquement sur devis (formule privée/entreprise).",
    priceQuote: "Sur devis",
    priceDefault: "La formule par défaut (Free) est toujours à 0 ₺.",
    sold: "formules vendues",
    accountUsers: "{{n}} comptes sur cet ancien plan de compte",
    soldNote: "Cette formule a été vendue {{n}} fois. Les modifications ne s’appliquent qu’aux NOUVELLES ventes ; les formules vendues gardent les nombres achetés (contrat). Si un client a besoin de plus, la montée en gamme est une vente distincte.",
    updatedNewSalesOnly: "Plan mis à jour · appliqué aux nouvelles ventes ; {{n}} formules vendues gardent les nombres achetés.",
    errors: {
      defaultLocked: "La formule par défaut (Free) ne peut pas être modifiée dans le modèle de formules.",
      defaultPrice: "La formule par défaut est gratuite (0 ₺).",
      priceZero: "Une formule payante ne peut pas coûter 0 — laissez vide (sur devis) ou saisissez un prix.",
      migrationRequired: "La migration 059 est requise pour les prix.",
      invalid: "Valeur invalide.",
    },
  },
  // ─── Admin: kullanıcı paketleri + Paket ver (2026-10-16) ─────────
  adminPackages: {
    title: "Formules",
    modeNote: "Modèle par formule : le plan du compte ne fixe aucune limite ; celles de chaque mariage viennent de sa formule. Donnez aux clients entreprise une formule à limites personnalisées.",
    grant: "Attribuer une formule",
    guests: "{{n}} invités",
    grantTitle: "Attribuer une formule",
    grantHint: "1 commande = 1 formule : une commande manuelle payée est créée. TOUS les nombres de la formule viennent de sa définition (Formules). Le montant peut être 0 ou remisé ; au-delà de 0, une référence de paiement est obligatoire. Le motif est inscrit dans la note interne et le registre. Si vous choisissez un mariage, la formule lui est attribuée (la formule Free / de transition prend fin) ; sinon l'utilisateur l'utilise depuis Mes formules.",
    plan: "Formule",
    amount: "Montant (₺)",
    paymentNote: "Référence de paiement (obligatoire)",
    duplicateConfirm: "La même formule a déjà été attribuée à cet utilisateur dans les 10 dernières minutes. En attribuer une seconde ? (S’il s’agit d’un second onglet / d’une nouvelle tentative, choisissez Annuler.)",
    duplicateSkipped: "Aucune seconde formule attribuée — celle des 10 dernières minutes reste valable.",
    revoke: "Retirer",
    revokePrompt: "Retirer la formule « {{label}} » ({{wedding}}) ? Sans autre formule, le mariage est suspendu (plus de nouveaux invités/envois, rien n’est supprimé). Motif (obligatoire) :",
    revoked: "Formule {{label}} retirée.",
    wedding: "Mariage",
    weddingNone: "Ne pas attribuer — laisser disponible",
    weddingOption: "{{title}} — actuellement : {{pkg}}",
    reason: "Motif",
    reasonPh: "ex. vente par téléphone, compensation, accord entreprise",
    submit: "Attribuer la formule",
    granted: "Formule attribuée : {{number}}",
    grantedTo: "Formule attribuée : {{number}} → {{title}}",
    packagesMode: "Le compte est au modèle par formule — le plan du compte ne peut pas être modifié ; utilisez « Attribuer une formule ».",
    errors: {
      packagesUnavailable: "Impossible d'attribuer une formule avant l'application de la migration 058.",
      weddingNotFound: "Ce mariage n'appartient pas à cet utilisateur.",
      ordersUnavailable: "Table des commandes absente (migration 053/055).",
      generic: "Impossible d'attribuer la formule : {{error}}",
      paymentRef: "Une référence de paiement (reçu / libellé de virement) est obligatoire si le montant dépasse 0.",
      targetHasPackage: "Ce mariage a déjà une formule payée — une formule par mariage.",
      packageNotFound: "Définition de formule introuvable ou inactive.",
      packageNotSellable: "La formule par défaut (Free) ne peut pas être attribuée — le compte l’a déjà.",
      reason: "Un motif est requis (au moins 3 caractères).",
      notActive: "La formule est déjà terminée ou retirée.",
      notFound: "La formule n’appartient pas à cet utilisateur.",
    },
  },

  // ─── Paketlerim (paket modeli, 2026-10-16) ─────────
  packages: {
    title: "Mes formules",
    subtitle: "Chaque mariage est lié à une formule. Votre compte dispose d'une formule Free ; chaque commande payée est une nouvelle formule.",
    buy: "Acheter une formule",
    loadFailed: "Impossible de charger les formules.",
    tileAvailable: "Disponibles",
    tileInUse: "Utilisées",
    tilePending: "En attente de paiement",
    tabPackages: "Formules",
    tabOrders: "Commandes",
    available: "Disponibles",
    inUse: "Utilisées",
    pending: "En attente de paiement",
    endedTitle: "Terminées",
    noneAvailable: "Aucune formule disponible. Achetez-en une pour un nouveau mariage.",
    limits: "{{guests}} invités · {{media}} photos/vidéos · {{storage}}",
    freeName: "Free",
    legacyName: "{{plan}} (transition)",
    freeHint: "Une fois par compte. Consommée lorsque le mariage passe à une formule payante.",
    paidHint: "Le service commence dès son attribution à un mariage.",
    pendingHint: "Commande : {{date}}. Les instructions de virement sont dans votre e-mail — indiquez le numéro de commande en référence. La formule devient disponible une fois le paiement confirmé.",
    ended: {
      replaced: "Remplacée par une formule payante",
      revoked: "Retirée",
      cancelled: "Annulée / remboursée",
    },
    openWedding: "Créer un mariage avec cette formule",
    orderUnassigned: "Pas encore attribuée à un mariage",
    orderPendingShort: "Paiement en attente",
    addonsTitle: "Packs d'invités supplémentaires (QR)",
    addonSeats: "+{{seats}} invités",
  },

  // ─── Quota d’invités + inscription QR supplémentaire (carte commune) ────
  guestCapacity: {
    title: "Quota d’invités",
    breakdown: "Limite de la formule {{limit}} · supplément {{extra}} (QR uniquement)",
    full: "Quota atteint — les nouvelles inscriptions par QR sont refusées. Les invités sont invités à prévenir les mariés. Ouvrez un pack supplémentaire pour l’augmenter.",
    almost: "Presque plein. Une fois plein, les nouvelles inscriptions par QR sont refusées.",
    qrExtra: "Inscriptions QR supplémentaires",
    off: "Désactivé",
    on: "Activé · +{{seats}}",
    packButton: "+{{seats}} invités · {{price}}",
    statusPending: "paiement en attente",
    statusPaid: "payé",
    due: "À régler : {{amount}} (virement — détails par e-mail)",
    withdraw: "Retirer",
    cancel: "Annuler",
    withdrawConfirm: "Retirer le pack +{{seats}} ? Les places supplémentaires ferment ; aucun frais.",
    cancelConfirmAdmin: "Annuler le pack +{{seats}} ? Les places ferment aussitôt (remboursement à votre charge s’il est payé).",
    withdrawn: "Pack +{{seats}} fermé.",
    opened: "+{{seats}} invités supplémentaires ouverts.",
    confirmTitle: "+{{seats}} invités supplémentaires",
    confirmLimit: "La limite d’inscription QR passe de {{from}} à {{to}}.",
    confirmQrOnly: "Les places supplémentaires ne concernent que les inscriptions QR ; l’ajout manuel reste dans la limite de la formule.",
    confirmBilling: "Le pack s’ouvre IMMÉDIATEMENT ; une commande « paiement en attente » de {{price}} est créée, payable par virement.",
    confirmUnpaid: "Sans paiement sous {{days}} jours, le pack est annulé automatiquement et les inscriptions supplémentaires s’arrêtent (les invités inscrits restent). Un seul pack impayé à la fois.",
    confirmWithdraw: "Vous pouvez retirer le pack gratuitement tant que personne ne s’est inscrit par QR depuis son ouverture.",
    comp: "Offert (gratuit)",
    pendingExists: "Un pack supplémentaire est impayé — un nouveau ne peut pas être ouvert avant son paiement (ou son retrait).",
    compReason: "Motif de la gratuité (obligatoire)",
    compReasonPh: "ex. dédommagement, accord entreprise",
    accept: "J’ai lu et j’accepte le prix et les conditions.",
    confirmButton: "Ouvrir +{{seats}} invités",
    close: "Annuler",
    loadFailed: "Impossible de charger le quota d’invités.",
    retry: "Réessayer",
    migrationHint: "Les packs supplémentaires nécessitent la migration 056 (la règle de quota s’applique déjà).",
    errors: {
      unavailable: "Les packs supplémentaires ne peuvent pas être ouverts pour le moment.",
      disabled: "Les packs d’invités supplémentaires sont désactivés.",
      unknownPack: "Ce pack n’est plus proposé — actualisez la page.",
      duplicate: "Ce pack vient d’être ouvert — actualisez la page.",
      inUse: "Les places de ce pack sont utilisées ; impossible de le retirer.",
      paid: "Un pack payé ne peut pas être retiré — contactez le support.",
      generic: "Échec de l’action : {{error}}",
      pendingExists: "Un pack supplémentaire est impayé — payez-le ou retirez-le d’abord.",
      suspended: "Le mariage n’a pas de formule (suspendu) — impossible d’ouvrir un pack.",
      reason: "Un motif est requis pour un pack gratuit.",
    },
    pkg: {
      title: "Formule",
      order: "commande {{number}}",
      account: "forfait du compte",
      trial: "essai gratuit — sans pack",
      media: "Photos/vidéos",
      storage: "Stockage",
      sms: "SMS",
      free: "formule Free",
      legacy: "formule de transition (ancien plan du compte)",
      suspended: "aucune formule — mariage suspendu",
    },
  },

  planChange: {
    accountPlanWarning: "Le forfait du compte s'applique sans limite de durée à TOUS les mariages sans pack attribué (tout le compte). Pro et Max sont vendus par mariage : ils ne peuvent pas être attribués ici — ouvrez une « Commande manuelle » dans Ventes & Site → Vente en ligne (Quantité pour plusieurs packs). Le forfait du compte sert uniquement au retour à Free et aux accords personnalisés (entreprise/abonnement). Pour un ancien compte Pro/Max, utilisez l'outil « Forfait du compte → packs par mariage » ci-dessous.",
    title: "Changer le forfait du compte",
    rowLabel: "Forfait du compte",
    perWeddingOption: "Vendu par mariage — via « Commande manuelle »",
    perWeddingPlan: "Pro/Max ne peuvent pas être attribués comme forfait du compte — ils sont vendus par mariage. Utilisez Ventes & Site → Vente en ligne → « Commande manuelle ».",
    conversion: {
      title: "Forfait du compte → packs par mariage",
      desc: "Ce compte a reçu le forfait {{plan}} avant le modèle « un pack = un mariage » : tous les mariages sans pack utilisent les limites {{plan}} et n'ont pas de numéro de commande. La conversion ouvre une commande de transition à 0 ₺ pour chaque mariage sélectionné (numéro commençant par G, inscrite au registre) ; le mariage ne perd aucune limite. Le compte passe au forfait {{to}} (essai gratuit).",
      notConvertible: "Le forfait de ce compte ({{plan}}) est un forfait personnalisé : il reste volontairement global (entreprise). Il n'est pas converti.",
      guests: "{{count}} invités",
      hasOrder: "Pack existant : {{number}}",
      notOwner: "Appartient à un autre compte",
      archived: "archivé",
      unselectedWarn: "{{count}} mariage(s) non sélectionné(s) passent aux limites de l'essai gratuit ({{guests}} invités) — aucune donnée n'est supprimée, mais les nouvelles inscriptions et envois au-delà de la limite s'arrêtent. Ne sélectionnez pas les mariages de test.",
      button: "Convertir en packs par mariage",
      confirm: "Un pack de transition {{plan}} sera ouvert pour {{count}} mariage(s) et le compte passera au forfait {{to}}. Action irréversible (les commandes peuvent être annulées une à une si besoin). Continuer ?",
      done: "Converti — {{count}} commande(s) de transition : {{numbers}}",
      doneNone: "Converti — le compte est passé à {{to}}, aucun pack ouvert",
      failed: "Conversion impossible : {{error}}",
      planChanged: "Le forfait du compte a changé entre-temps — rechargez la page et réessayez",
      loadFailed: "Impossible de charger les informations de conversion : {{error}}",
    },
  },

  privacyAdmin: {
    title: "Demandes de confidentialité (KVKK)",
    description: "Quand une personne demande la suppression de ses données : retrouvez ses fiches invité dans tous les mariages par numéro de téléphone, prévisualisez puis supprimez/anonymisez en une fois. Recherches et suppressions sont journalisées (numéro masqué).",
    phoneLabel: "Numéro de téléphone",
    phoneHint: "Saisissez-le comme 0555 123 45 67 ou +33….",
    willSearch: "Recherche : {{phone}}",
    invalidPhone: "Saisissez un numéro valide.",
    search: "Rechercher",
    lookupFailed: "Recherche impossible : {{error}}",
    resultTitle: "Résultats pour {{phone}}",
    resultMeta: "Codes de vérification : {{authCodes}} · Demandes de devis : {{leads}} · Entrées du journal : {{audit}}",
    ordersKept: "{{count}} commandes pour ce numéro — conservées 10 ans comme pièces de facturation (obligation fiscale) ; cet outil ne les supprime pas.",
    organizerNote: "Un compte organisateur est aussi enregistré avec ce numéro. Cet outil ne supprime pas les comptes organisateur ; fermez-le séparément si besoin :",
    nothing: "Aucune donnée trouvée pour ce numéro.",
    noGuests: "Aucune fiche invité ; seuls les codes, demandes de devis et entrées du journal seront nettoyés.",
    noName: "(sans nom)",
    guestActive: "Invité actif",
    guestRemoved: "Retiré du mariage",
    counts: "{{media}} médias · {{comments}} commentaires · {{likes}} j’aime · {{rsvp}} RSVP · {{sms}} SMS",
    eraseExplain: "Supprimés : photos/vidéos de l’invité (avec les fichiers), commentaires et j’aime, RSVP, codes de vérification, demandes de devis et sessions ouvertes. La fiche invité est anonymisée (nom et téléphone retirés) ; le numéro est masqué dans les envois SMS et le journal. Action irréversible.",
    erase: "Supprimer et anonymiser",
    eraseConfirm: "{{count}} fiches invité pour {{phone}} et toutes les données liées seront supprimées définitivement. Action irréversible. Continuer ?",
    erased: "Suppression terminée",
    eraseFailed: "Suppression impossible : {{error}}",
    erasedSummary: "{{phone}} : {{guests}} fiches invité anonymisées, {{media}} médias supprimés, numéro masqué dans {{audit}} entrées du journal.",
  },

  landing: {
    meta: {
      title: "{{brand}} — Chaque instant manqué, dans un seul album",
      description: "Vos invités scannent un QR code ; chaque photo et vidéo arrive dans un seul album en qualité originale, et celles que vous approuvez passent sur le grand écran de la salle. Aucune application à télécharger.",
    },
    nav: {
      home: "Accueil {{brand}}",
      how: "Comment ça marche",
      sahne: "Sahne",
      themes: "Invitations",
      plans: "Offres",
      faq: "FAQ",
      contact: "Devis",
      login: "Se connecter",
      cta: "Demander un devis",
      menu: "Ouvrir le menu",
      close: "Fermer le menu",
      skip: "Aller au contenu",
    },
    hero: {
      eyebrow: "L’album de mariage par QR code",
      titleA: "Chaque instant manqué,",
      titleB: "dans un seul album.",
      lead: "Vos invités scannent un QR code : leurs photos et vidéos arrivent dans votre album en qualité originale. Celles que vous approuvez défilent toute la soirée sur le grand écran.",
      ctaPrimary: "Demander un devis",
      ctaHow: "Voir comment ça marche",
      live: "En direct",
      live1: "Nouvelle photo de la table 7",
      live2: "Elif a partagé une vidéo",
      live3: "14 cœurs pour la première danse",
      promise1: "Aucune application — scanner le QR suffit",
      promise2: "Qualité originale, sans compression",
      promise3: "Les photos approuvées passent à l’écran en quelques secondes",
    },
    marquee: {
      m1: "Cérémonie",
      m2: "Soirée du henné",
      m3: "Mariage",
      m4: "Fiançailles",
      m5: "After party",
      m6: "Promesse",
    },
    manifesto: {
      eyebrow: "Ça vous rappelle quelque chose ?",
      body: "Le lendemain du mariage, les plus belles images de la soirée sont éparpillées sur quarante-sept téléphones, douze groupes WhatsApp et un « je vous les envoie plus tard » qui n’arrivera jamais.",
      resolve: "Nous les réunissons dans un seul album, dans leur qualité d’origine.",
      chip1: "« Tu peux m’envoyer les photos ? »",
      chip2: "WhatsApp · compressé",
      chip3: "Ce lien a expiré",
      chip4: "« Je les envoie plus tard » — cousin Emre",
      chip5: "Stockage saturé",
      chip6: "Pas d’accès au dossier Drive",
    },
    how: {
      eyebrow: "Comment ça marche",
      title: "Trois étapes.",
      titleAccent: "Zéro application.",
      lead: "Aussi simple qu’un appareil photo pour vos invités. Un seul album pour vous.",
      step1Title: "Scanner",
      step1Body: "Vos invités scannent le QR code du marque-place, du faire-part ou du panneau d’accueil avec l’appareil photo de leur téléphone. Ni téléchargement, ni mot de passe.",
      step2Title: "Partager",
      step2Body: "Ils se connectent avec un code à usage unique reçu par SMS, puis envoient photos et vidéos. Aucune compression — exactement ce qu’ils ont filmé.",
      step3Title: "Regarder",
      step3Body: "Chaque photo approuvée arrive sur le grand écran de la salle (Sahne) — avec les cœurs envoyés depuis les téléphones des invités.",
      cardShare: "Partagez vos souvenirs avec nous",
      cardTable: "Table 7",
      cardScan: "Scannez avec votre appareil photo",
      phoneTitle: "Partager un souvenir",
      phoneVerified: "Votre numéro est vérifié",
      phoneUploading: "Envoi de 4 fichiers",
      phoneOriginal: "Qualité originale",
      phoneSend: "Partager",
      tryAsGuest: "Essayer comme un invité",
      tryAsGuestNote: "Mariage exemple — sans numéro de téléphone ; les envois sont supprimés chaque nuit.",
    },
    sahne: {
      eyebrow: "Sahne",
      title: "Les photos de la soirée,",
      titleAccent: "instantanément",
      titleEnd: "sur grand écran.",
      lead: "L’invité photographie, vous approuvez, l’image s’affiche en quelques secondes. Les cœurs envoyés depuis les téléphones flottent à l’écran, les commentaires deviennent des bulles.",
      live: "En direct",
      watching: "{{count}} spectateurs",
      sharedBy: "Partagé par {{name}}",
      comment1: "Cette danse est mythique 💃",
      comment2: "Regardez le sourire de la mariée ❤️",
      comment3: "J’arrive pour le halay !",
      join: "Rejoindre la fête",
      joinHint: "Partagez des photos & envoyez des cœurs",
      f1Title: "À l’écran en quelques secondes",
      f1Body: "Dès que vous approuvez, l’image apparaît sur tous les écrans de la salle en même temps.",
      f2Title: "Cœurs et commentaires depuis le téléphone",
      f2Body: "Les invités réagissent d’un geste ; un coin de l’écran montre qui regarde.",
      f3Title: "C’est vous qui pilotez l’écran",
      f3Body: "Depuis votre téléphone, choisissez la suivante, mettez une photo en avant, faites une pause ou masquez-la.",
      rejiLabel: "Reji",
      rejiNext: "À suivre",
      rejiSpotlight: "Mettre en avant",
      videoCaption: "Lors d’un vrai mariage : Sahne tout au long de la soirée",
    },
    control: {
      eyebrow: "Contrôle",
      title: "Le rédacteur en chef de la soirée,",
      titleAccent: "c’est vous.",
      lead: "Vous décidez de ce qui entre dans l’album et de ce qui passe à l’écran. Le tableau de bord s’occupe du reste.",
      modTitle: "Validation avant diffusion",
      modBody: "Chaque cliché passe d’abord par la file de modération. Approuvez, refusez — et si besoin, bloquez l’expéditeur d’un geste.",
      modPending: "{{count}} clichés en attente",
      modApprove: "Approuver",
      modReject: "Refuser",
      otpTitle: "Uniquement de vrais invités",
      otpBody: "La connexion se fait avec un code à usage unique envoyé sur le téléphone. Votre album n’est pas un lien public.",
      otpLabel: "Code de vérification",
      rsvpTitle: "RSVP en temps réel",
      rsvpBody: "Qui vient, qui ne vient pas, qui hésite encore — en direct sur votre tableau de bord.",
      rsvpYes: "Présents",
      rsvpNo: "Absents",
      rsvpPending: "Sans réponse",
      smsTitle: "Invitations et rappels par SMS",
      smsBody: "Une invitation pour tous, un rappel délicat pour ceux qui n’ont pas répondu. Choisissez le public, programmez l’envoi.",
      smsPreview: "Chère Ayşe Yılmaz, nous serions ravis de vous compter parmi nous au mariage de Deniz & Arda le 23 août. Touchez le lien pour nous indiquer votre présence.",
      smsSegment: "Sans RSVP",
      qrTitle: "Statistiques QR",
      qrBody: "Votre invitation est-elle vraiment ouverte ? Voyez combien de personnes l’ont scannée, jour après jour.",
      qrWeek: "7 derniers jours",
      eventsTitle: "Henné + Mariage",
      eventsBody: "Deux événements, un seul album. Une fois le premier passé, le compte à rebours et le lieu basculent seuls sur le suivant.",
      eventsKina: "Henné",
      eventsDugun: "Mariage",
      eventsDone: "Passé",
      langTitle: "Quatre langues",
      langBody: "Turc, anglais, français, espagnol — chaque invité choisit la sienne.",
      qualityTitle: "Qualité originale",
      qualityBody: "Aucune compression. Ce qui est sur le téléphone de l’invité est ce qui arrive dans l’album.",
      qualityPhoto: "par photo",
      qualityVideo: "par vidéo",
      notifyTitle: "Alertes Telegram",
      notifyBody: "Soyez prévenu dès qu’un nouveau cliché attend votre validation.",
      notifySample: "3 nouvelles photos en attente",
    },
    themes: {
      eyebrow: "Invitation",
      title: "Votre invitation n’est pas un lien.",
      titleAccent: "C’est une scène d’ouverture.",
      lead: "Le premier écran que voit l’invité après avoir scanné : des thèmes cinématographiques qui se déploient au défilement. Prévisualisez-les dès maintenant.",
      count: "{{count}} thèmes",
      preview: "Aperçu",
      drag: "Faites glisser pour parcourir",
      premium: "Premium",
      classic: "Classique",
    },
    compare: {
      eyebrow: "Comparatif",
      title: "Pourquoi un groupe WhatsApp",
      titleAccent: "ne suffit pas.",
      feature: "Fonctionnalité",
      colWhatsapp: "Groupe WhatsApp",
      colDrive: "Dossier Drive",
      colQrAlbum: "Album QR classique",
      rowQuality: "Qualité originale",
      rowSingle: "Tout au même endroit",
      rowLive: "Sur grand écran toute la soirée",
      rowModeration: "Validation avant diffusion",
      rowVerified: "Invités vérifiés uniquement",
      rowNoApp: "Rien à installer pour les invités",
      rowVideo: "Vidéo",
      yes: "Oui",
      no: "Non",
      partial: "En partie",
    },
    proof: {
      eyebrow: "Les couples racontent",
      title: "De vrais mariages,",
      titleAccent: "de vrais instants.",
      statWeddings: "albums de mariage",
      statMedia: "photos et vidéos partagées",
      rating: "{{n}} sur 5",
    },
    checkout: {
      eyebrow: "Achat en ligne",
      title: "Achetez votre formule",
      lead: "Choisissez votre formule, saisissez vos informations et confirmez la commande. Paiement par virement ; votre compte s’ouvre dès réception.",
      loading: "Chargement",
      closedTitle: "La vente en ligne est fermée pour le moment",
      closedBody: "Demandez une formule via le formulaire de devis en deux minutes ; nous répondons le jour même.",
      closedCta: "Aller au formulaire de devis",
      packageLabel: "Formule",
      packageGuests: "jusqu’à {{n}} invités",
      packageQuote: "Sur devis",
      name: "Nom complet",
      email: "E-mail",
      phone: "Téléphone",
      eventDate: "Date de l’événement",
      address: "Adresse de facturation",
      addressHint: "Adresse complète pour le contrat et la facture.",
      taxId: "N° d’identité / fiscal",
      taxIdHint: "Pour la facture ; numéro fiscal si vous achetez pour une société.",
      optional: "facultatif",
      docsTitle: "Informations précontractuelles et contrat de vente à distance",
      docsLangNote: "Les textes contractuels sont en turc (droit turc).",
      accept: "J’ai lu et j’accepte le formulaire d’information précontractuelle et le contrat de vente à distance.",
      summaryTitle: "Récapitulatif",
      summaryOnce: "Paiement unique · toutes taxes comprises",
      summaryPick: "Choisissez votre formule.",
      step1: "1 — Vous confirmez la commande.",
      step2: "2 — Nous envoyons les coordonnées de paiement sous 1 jour ouvré.",
      step3: "3 — À réception du paiement, votre compte s’ouvre et les identifiants arrivent par e-mail.",
      submit: "Confirmer la commande",
      sending: "Envoi…",
      seller: "Vendeur : {{name}}",
      errField: "Vérifiez ce champ.",
      errAccept: "Acceptez les textes contractuels pour continuer.",
      errInvalid: "Certains champs sont manquants ou invalides.",
      errPackage: "Choisissez une formule disponible en ligne.",
      errVerify: "Vérification de sécurité en attente — réessayez dans quelques secondes.",
      errVerifyFailed: "La vérification de sécurité n’a pas pu se charger. Actualisez la page ou utilisez le formulaire de devis.",
      errClosed: "Cette formule n’est pas vendue en ligne pour le moment — utilisez le formulaire de devis.",
      errUnavailable: "Les commandes ne peuvent pas être prises pour le moment. Utilisez le formulaire de devis.",
      errTermsChanged: "Le prix ou les conditions du contrat ont été mis à jour pendant votre lecture. Veuillez relire le texte actuel et confirmer à nouveau.",
      errFailed: "La commande n’a pas pu être envoyée. Réessayez.",
      toastSent: "Commande reçue",
      successTitle: "Commande reçue",
      successBody: "Votre numéro de commande est {{number}}. Nous enverrons les coordonnées de paiement à {{email}} sous 1 jour ouvré.",
      successNext: "Dès réception du paiement, votre compte organisateur s’ouvre ; identifiants et copie des contrats arrivent par e-mail.",
      backHome: "Retour à l’accueil",
    },
    plans: {
      eyebrow: "Offres",
      title: "Trois formules,",
      titleAccent: "selon vos invités.",
      lead: "Les formules diffèrent par le nombre d’invités, de photos/vidéos et le stockage. Choisissons ensemble la bonne.",
      freeTagline: "Pour essayer et pour les petites réceptions",
      proTagline: "Pour la plupart des mariages",
      maxTagline: "Pour les grands mariages et les organisateurs",
      limitGuests: "Invités",
      guestsUpTo: "jusqu’à {{n}}",
      limitMedia: "Photos et vidéos / mariage",
      limitStorage: "Stockage",
      recommended: "Recommandé",
      ctaFree: "Demander la formule gratuite",
      ctaPaid: "Demander un devis",
      ctaBuy: "Acheter",
      note: "Le prix dépend de vos événements et du nombre d’invités — il suffit de remplir le formulaire.",
      priceOnce: "paiement unique",
      priceTrial: "essai gratuit",
      priceQuote: "Sur devis",
      customLine: "Un événement plus grand ?",
      customCta: "Demandez un devis pour une formule sur mesure",
      tierGuests: "{{range}} invités",
      priceNote: "Paiement unique, sans abonnement. Soirée du henné et mariage au même prix ; design des cartes de table et du panneau d’accueil inclus.",
      retention: "L’album reste en ligne au moins {{months}} mois ; téléchargez-le en entier à tout moment.",
    },
    print: {
      eyebrow: "Impression",
      title: "Prêts pour les tables.",
      titleAccent: "Chaque surface, une invitation.",
      lead: "Imprimez votre QR code dans le style de votre mariage. Du marque-place au panneau d’accueil, téléchargez nos exemples.",
      tableCard: "Marque-place",
      tableCardSize: "A6 · 105 × 148 mm",
      sign: "Panneau d’accueil",
      signSize: "50 × 70 cm",
      handCard: "Carte à remettre",
      handCardSize: "85 × 55 mm",
      download: "PDF d’exemple",
      sampleNote: "Exemples de design — le QR code ouvre une page d’invitation d’exemple. Les versions avec votre propre QR arriveront dans l’espace organisateur.",
    },
    contact: {
      eyebrow: "Devis",
      title: "Votre prix",
      titleAccent: "en 30 secondes.",
      lead: "Choisissez le nombre d’invités et la date, dites-nous comment vous joindre — nous vous envoyons votre devis rapidement.",
      point1: "Henné, cérémonie et mariage dans un seul devis",
      point2: "Design des marque-places et panneaux inclus",
      point3: "Aucune pression commerciale — juste une réponse",
      directLabel: "Vous préférez l’e-mail ?",
      directCta: "Écrivez-nous",
      step1: "Votre événement",
      step2: "Comment vous joindre ?",
      stepCount: "Étape {{n}} sur 2",
      next: "Continuer",
      back: "Retour",
      addNote: "Ajouter une note",
      name: "Nom complet",
      namePh: "Ayşe Yılmaz",
      email: "E-mail",
      emailPh: "vous@exemple.com",
      phone: "Téléphone",
      eventType: "Événement",
      eventDate: "Date de l’événement",
      package: "Formule",
      packageHint: "Choisissez la formule adaptée à votre nombre d’invités.",
      packageGuests: "jusqu’à {{n}} invités",
      packageCustom: "Plus grand · devis sur mesure",
      estimate: "Prix estimé",
      message: "Votre message",
      messagePh: "Lieu, horaire, tout ce qui vous vient à l’esprit…",
      optional: "facultatif",
      evWedding: "Mariage",
      evWeddingHenna: "Mariage + Henné",
      evHenna: "Soirée du henné",
      evEngagement: "Fiançailles",
      evPromise: "Promesse",
      evOther: "Autre",
      rangeUpTo: "Jusqu’à {{n}}",
      rangeBetween: "{{min}}–{{max}}",
      rangeOver: "{{n}}+",
      consent: "Je consens expressément au transfert de mes données personnelles vers les prestataires situés à l’étranger mentionnés dans la politique de confidentialité (e-mail et hébergement) afin que ma demande de devis puisse être transmise.",
      submit: "Recevoir mon devis",
      sending: "Envoi…",
      successTitle: "Votre demande nous est parvenue.",
      successBody: "Nous vous répondrons rapidement à {{email}} ou par téléphone.",
      successAgain: "Envoyer une autre demande",
      errName: "Indiquez votre prénom et votre nom.",
      errEmail: "Saisissez une adresse e-mail valide.",
      errPhone: "Saisissez un numéro de téléphone valide.",
      errChoice: "Veuillez choisir une option.",
      errDate: "Choisissez une date à partir d’aujourd’hui.",
      errConsent: "Veuillez donner votre accord pour continuer.",
      errVerify: "La vérification de sécurité n’est pas terminée ; réessayez dans quelques secondes.",
      toastSent: "Votre demande a été envoyée.",
      toastFailed: "Envoi impossible — vous pouvez envoyer votre demande par e-mail.",
      toastInvalid: "Corrigez les champs signalés.",
      fallbackTitle: "Le formulaire n’a pas pu être envoyé.",
      fallbackBody: "Vos informations sont reprises dans un e-mail prêt à partir ; envoyez-le d’un geste.",
      fallbackCta: "Envoyer par e-mail",
      mailSubject: "Demande de devis — {{name}} · {{event}} · {{date}}",
      mailGreeting: "Bonjour,",
      mailIntro: "Je souhaite recevoir un devis pour {{brand}}.",
      mailMessage: "Message",
      mailPlan: "Formule",
      mailClosing: "Merci.",
    },
    faq: {
      eyebrow: "FAQ",
      title: "Questions fréquentes",
      q1: "Les invités doivent-ils télécharger une application ?",
      a1: "Non. Il suffit de scanner le QR code avec l’appareil photo du téléphone ; tout s’ouvre dans le navigateur. Ceux qui le souhaitent peuvent l’ajouter à leur écran d’accueil.",
      q2: "Les photos sont-elles compressées ?",
      a2: "Non. Les fichiers sont envoyés tels qu’ils sont sur le téléphone de l’invité — jusqu’à {{photo}} par photo et {{video}} par vidéo.",
      q3: "Qui peut voir l’album ?",
      a3: "Uniquement les invités connectés après vérification de leur numéro de téléphone — et ils ne voient que les clichés que vous avez approuvés.",
      q4: "Une image inappropriée peut-elle apparaître à l’écran ?",
      a4: "Non. Chaque cliché passe d’abord par la file de modération ; Sahne ne diffuse que ce que vous avez approuvé. Si besoin, vous bloquez l’expéditeur d’un geste.",
      q5: "Faut-il un album séparé pour le henné et le mariage ?",
      a5: "Non. Vous ajoutez les deux événements au même mariage ; une fois le premier passé, le compte à rebours et le lieu basculent seuls sur le second.",
      q6: "De quoi ai-je besoin pour Sahne ?",
      a6: "D’un écran ou d’un projecteur connecté à internet et d’un navigateur. Ouvrez Sahne en plein écran et pilotez le déroulé depuis Reji sur votre téléphone.",
      q7: "Certains invités viennent de l’étranger — est-ce un problème ?",
      a7: "Pas du tout. L’interface existe en turc, anglais, français et espagnol ; chaque invité choisit sa langue.",
      q8: "Combien de temps l’album reste-t-il en ligne ?",
      a8: "Votre album reste en ligne au moins {{months}} mois. Pendant ce temps, téléchargez en un clic depuis votre espace toutes les photos et vidéos approuvées, en qualité d’origine, au format ZIP.",
    },
    finale: {
      title1: "Avant la fin de la soirée,",
      title2: "les plus belles images",
      title3: "sont à l’écran.",
      lead: "Demandez votre devis — votre QR code sera prêt pour les tables.",
      cta: "Demander un devis",
      secondary: "Ouvrir un exemple d’invitation",
    },
    footer: {
      tagline: "Chaque instant manqué, dans un seul album.",
      product: "Produit",
      account: "Compte",
      organizerLogin: "Espace organisateur",
      quote: "Demander un devis",
      demo: "Exemple d’invitation",
      rights: "Tous droits réservés.",
    },
  },
  weddingTelegram: {
    title: "Notifications Telegram",
    subtitle: "Les événements de ce mariage arrivent dans les discussions Telegram choisies : la vôtre ou le groupe du couple / de l'équipe.",
    unavailable: "Les notifications Telegram ne peuvent pas être configurées pour le moment (mise à jour système en attente).",
    botMissing: "Le bot Telegram n'est pas configuré — prévenez l'administrateur.",
    loadFailed: "Impossible de charger les connexions Telegram.",
    retry: "Réessayer",
    connectPrivate: "Connecter mon Telegram",
    connectPrivateHint: "Les notifications n'arrivent qu'à vous.",
    connectGroup: "Ajouter à un groupe",
    connectGroupHint: "Le groupe du couple ou de l'équipe — vous choisissez le groupe dans Telegram.",
    waitingPrivate: "Ouvrez Telegram et appuyez sur « Démarrer ». La discussion apparaît ici une fois connectée.",
    waitingGroup: "Choisissez le groupe dans Telegram et ajoutez le bot. Il apparaît ici une fois connecté.",
    openTelegram: "Ouvrir dans Telegram",
    expiresIn: "Lien valable {{time}}",
    expired: "Le lien a expiré. Créez-en un nouveau.",
    cancel: "Annuler",
    linked: "Telegram connecté : {{name}}",
    linkFailed: "Impossible de créer le lien",
    chatsTitle: "Discussions connectées",
    empty: "Aucune discussion connectée pour l'instant.",
    private: "Personnel",
    group: "Groupe",
    unnamedPrivate: "Discussion personnelle",
    unnamedGroup: "Groupe",
    eventsLabel: "Types de notification pour {{name}}",
    remove: "Retirer",
    removeConfirm: "« {{name}} » ne recevra plus les notifications de ce mariage. Retirer ?",
    removed: "Discussion retirée",
    saved: "Choix de notifications enregistré",
    saveFailed: "Enregistrement impossible",
    stale: "Le choix a été modifié ailleurs — la version à jour est chargée.",
    footer: "Si vous bloquez le bot ou le retirez du groupe, la connexion disparaît d'elle-même. /status dans la discussion liste les mariages connectés.",
    events: {
      media_upload: "Nouveau média (en attente)",
      guest_join: "Nouvel invité",
      rsvp_submitted: "Réponse RSVP",
      comment_created: "Commentaire",
      capacity: "Alertes de capacité",
    },
    errors: {
      migration_required: "Les notifications Telegram ne peuvent pas être configurées pour le moment (mise à jour système en attente).",
      bot_unavailable: "Bot Telegram injoignable, réessayez dans un instant.",
      generic: "Erreur : {{error}}",
    },
  },

} as const;

export default fr;
